// import code from './code';
// npm 引入talCaptcha
var copy = require('./extend');
var _util = require('./_util');
// var _TalCaptcha = require('./talCaptcha.js');
import _TalCaptcha from '@udc/udc_captcha'
import TalUdcLogJSSDK from './udclogminisdk'

var reqMultipart = 'multipart/form-data;charset=UTF-8';
var userInfo = {}
var passport_host_v1 = '';
var passport_host_v2 = '';
var isOrg = false;// 是否是机构
var cg_host_v1 = '';
var cg_host_v2 = '';
var logHost = '';
var ucresHost = '';
var captchaContent = '';   // 图形验证码插入的父级元素
var awscDomain = "g" // 滑块cdn
var uniqCaptcha = Date.parse(new Date()) // 游客标识
var __udc_ctx = ''; // 微信授权参数
// 所有调用接口统一为https协议
var getProtocol = 'https:'
window.SET_APP_TAL_TOKEN = ''
// 人机验证失败厂商
var captchaFailVendor = []
// 获取环境判断
var getJudgeEnv = process.env.JUDGE_ENV || ''
// 滑块是否二次验证
window.ALI_AWSC_TRIGGE_NC = 0
// cdn外链sdk的情况下设置接口域名
var qrCodeBoxNode, startShow;
var emailRegular = /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,})$/


var domain = 'xueersi.com'
var slideCallback, slideParams, slidefailCallback, isH5, captchaLoding = false, configNVCInitParams = {};
// 错误码对应语言
var errMsgLang = {
  'cn': {
    '14100': '请求参数有误',
    '14102': '刷新频繁，请稍候再试',
    '14103': '刷新频繁，请稍候再试',
    '14104': '验证码错误或已过期',
    '14105': '验证码错误或已过期',
    '14106': '图形验证码不需要展示',
  },
  'en': {
    '14100': 'Request parameter error',
    '14102': 'Refresh too frequently, please try again later',
    '14103': 'Refresh too frequently, please try again later',
    '14104': 'Verification code error or expired',
    '14105': 'Verification code error or expired',
    '14106': 'Verification code does not need to be displayed',
  }
}
// 阿里验证码2.0实例
var ali20CaptchaInstance = null;
var sdkCallbackMethod = null;
// 保存验证码回调的上下文信息
var sdkCallbackContext = {
  method: null,
  params: null,
  captchaData: null
};
var ali20CaptchaConfig = {
  // 无痕模式配置
  invisible: {
    sceneId: '8tvl80fq',
    prefix: '4xv0sz'
  },
  // 滑块模式配置
  slide: {
    sceneId: '1atiy64k',
    prefix: '4xv0sz'
  }
};
function getParams(params) {
  return _util.getParams(params)
}

// 设置域名
function setRequestDomainVar(env, domain, entity) {
  var getAllVar = _util.setRequestDomain(env, domain, entity)
  passport_host_v1 = getAllVar.passport_host_v1
  passport_host_v2 = getAllVar.passport_host_v2
  cg_host_v1 = getAllVar.cg_host_v1
  cg_host_v2 = getAllVar.cg_host_v2
  ucresHost = getAllVar.ucresHost
}

var checkHeartbeatFlag = '',
  setHeartbeatFlag = '',
  intervalNum = null,
  intervalRenderDomNum = null

var TAL_UC = {
  /*
  * @discribe 用户注入方法
  * 都要写在这个方法之中
  * @method ready
  * @param {Function} 匿名函数方法
  * */
  rankConfig: function (options) {
     // 在初始化时禁用 console.clear
    //  if (typeof console !== 'undefined' && console.clear) {
    //   const originalClear = console.clear;
    //   console.clear = function() {
    //     console.warn('[Passport SDK] console.clear 被拦截，保留日志');
    //     // 不执行清空操作
    //   };
    // }
    var newOptions = {
      'client-id': options['client-id'] || '',
      'LANGUAGE': options['language'] || ''
    };
    if (options.captchaContent) {
      captchaContent = options.captchaContent
    }

    window.AliyunCaptchaConfig = {
      // 必填，验证码示例所属地区，支持中国内地（cn）、新加坡（sgp）
      region: "cn",
      // 必填，身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
      prefix: "4xv0sz",
    };
    // 支持业务方配置阿里验证码2.0参数
    if (options.aliCaptcha) {
      if (options.aliCaptcha.slide) {
        ali20CaptchaConfig.slide = options.aliCaptcha.slide
      }
      if (options.aliCaptcha.invisible) {
        ali20CaptchaConfig.invisible = options.aliCaptcha.invisible
      }
    }
    userInfo = copy.extend(true, {}, userInfo, newOptions)
    // console.log(ucresHost,'-----ucresHost')
    // console.log(options.entity,'options.entity')
    if (options.env) {
      setRequestDomainVar(options.env, options.domain, options.entity)
    } else {
      setRequestDomainVar(getJudgeEnv, options.domain, options.entity)
    }
    if (options.businessType && options.businessType === 2) {
      isOrg = true
    }
    // 如果有语言参数，设置语言
    // if (options.LANGUAGE) {
    //   _util.setLanguage(options.LANGUAGE)
    // }
    _util.setHeader(userInfo, options.domain, ucresHost, options)
    // console.log(ucresHost,'ucresHost-----')
    // 设备信息上报机制升级，0-6点首次、6-12点首次、12-18点首次、18-24首次
    // 获取上一次上报设备信息的日期
    var upLoadTime = _util.resetLocalStorage.getItem('tal-passport-upLoad-deviceInfo-timeStamp') || ''
    if (upLoadTime) {
      // 并非首次上传，之前上传过，判断该时间是否在当天的上报时间段，时间与当前时间在同一天，判断时间段，不在同一天即时上报即可
      // 获取当前时间日期
      var currentDate = _util.getCurrentDate(),
        // 上次上报的日期
        lastUpLoadDate = _util.timestampToDate(parseFloat(upLoadTime))
      // 如果上一次上报的日期与当前日期在同一天，判断小时数是否在相同的时间段，在同一时间段不上报，否则上报并且修改上一次的存储上报时间为当前时间戳
      if (lastUpLoadDate.date == currentDate.date) {
        // 上一次上报是在当天时间，判断上一次上报的时间和当前时间是否在同一个上报时间段内，在不作处理，否则上报，并且修改上一次存储的上报时间为当前时间戳
        var lastHours = lastUpLoadDate.hours,
          currentHours = currentDate.hours
        if ((lastHours >= 0 && lastHours < 6 && currentHours >= 6) || (lastHours >= 6 && lastHours < 12 && currentHours >= 12) || (lastHours >= 12 && lastHours < 18 && currentHours >= 18) || (lastHours >= 18 && lastHours < 24 && currentHours < 18)) {
          // 上报一次
          _util.upLoadDeviceInfoFn(ucresHost, passport_host_v1)
        }

      } else {
        // 上一次上报时间并非当天时间，当天一定是第一次，直接上报即可
        _util.upLoadDeviceInfoFn(ucresHost, passport_host_v1)
      }

    } else {
      // 不存在说明之前没有上报该信息，上报并且存储上报时间
      _util.upLoadDeviceInfoFn(ucresHost, passport_host_v1)
    }

    /******设置心跳逻辑处理*********/
    var _t = this
    // 设置心跳时间
    var setHeartbeatTime = 5 * 60 * 1000
    // 心跳逻辑处理方法
    function setHeartbeat() {
      // 首先判断是否存在登录态，存在才启动心跳逻辑，每次轮询都是相同的逻辑
      _t.asyncCheckLogin().then(function (res) {
        // 获取上一次心跳执行时间
        var prevTimeStamp = (_util.isHttpProtocol() ? _util.getCookieValue('tal-passport-run-heartbeat-timeStamp') : _util.resetLocalStorage.getItem('tal-passport-run-heartbeat-timeStamp')) || 0,
          // 毫秒级时间戳
          curTimeStamp = new Date().getTime(),
          timeDiff = curTimeStamp - prevTimeStamp,
          lastTimeStamp = (setHeartbeatTime - timeDiff) > 0 ? (setHeartbeatTime - timeDiff) : setHeartbeatTime,
          lastTimeStamp = lastTimeStamp > setHeartbeatTime ? setHeartbeatTime : (lastTimeStamp < 0 ? 0 : lastTimeStamp)
        console.log(lastTimeStamp, '==lastTimeStamp===')
        // 判断timeDiff是否大于5min，如果大于5min就按照5min计算，负数就按照0计算
        if (lastTimeStamp < setHeartbeatTime) {
          console.log('延迟加载========')
          // 避免重复请求心跳，如果存在上一次先清除
          if (window.tal_passport_checkopen_isheartbeat) {
            window.clearTimeout(window.tal_passport_checkopen_isheartbeat)
          }
          // 延迟 lastTimeStamp 毫秒之后执行心跳
          window.tal_passport_checkopen_isheartbeat = window.setTimeout(setHeartbeat, lastTimeStamp)
        } else {
          console.log('存储====')
          // 立即执行心跳，本地存储执行心跳时间，为了开两个窗口同时请求两次心跳接口，但可能会存在接口响应时间段的误差
          var _domains = ["com", "net", "org", "gov", "cn", "com\\.cn", "net\\.cn", "org\\.cn", "gov\\.cn", "[a-z]{2}\\.cn", "vip", "tech", "tv", "co", "live", "xyz", "top", "info", "mobi", "group", "中国"]
          var _str = _domains.join("|")
          var _pattern = new RegExp("[\\w-_]+\\.(" + _str + ")$", "i")
          var _res = _pattern.exec(options.domain)
          _res = _res || []
          if (!_res[0]) {
            // 定级域名不合法
            console.log('******------域名不在合法的范围内------******')
          }
          // 判断是否为http/https协议，是执行cookie存储，否则执行localStorage存储，目的为了解决非http/https协议下无法存储cookie问题
          if (_util.isHttpProtocol()) {
            // http/https协议
            _util.setCookieValue('tal-passport-run-heartbeat-timeStamp', new Date().getTime(), _res[0])
          } else {
            // 非http/https协议
            _util.resetLocalStorage.setItem('tal-passport-run-heartbeat-timeStamp', new Date().getTime())
          }
          // 执行心跳方法，心跳方法执行完成之后重新启动5min的轮询setHeartbeat方法
          _t.checkHeartbeat({
            complete: function (resData) {
              // 当错误码为 11100-11199 时，未登录或者登录失效，不启动心跳5分钟轮询
              if (resData.errcode || resData.errcode == 0) {
                var getErrcode = parseInt(resData.errcode)
                if (getErrcode >= 11100 && getErrcode <= 11199) return false
              }
              // 避免重复请求心跳，如果存在上一次先清除
              if (window.tal_passport_setheartbeat_flag) {
                window.clearTimeout(window.tal_passport_setheartbeat_flag)
              }
              // 成功之后5分钟请求一次心跳接口
              window.tal_passport_setheartbeat_flag = window.setTimeout(setHeartbeat, setHeartbeatTime)
            }
          })
        }
      }).catch(function (err) {
        console.log('haode======err')
        // 避免重复请求心跳，如果存在上一次先清除
        if (window.tal_passport_heartbeat_checkLogin_flag) {
          window.clearTimeout(window.tal_passport_heartbeat_checkLogin_flag)
        }
        // 未登录，不存在登录态时，10s之后重新启动心跳逻辑，避免checkLogin接口处于心跳时期接口因网络等特殊原因突然造成失败，后续恢复正常之后没有心跳问题
        window.tal_passport_heartbeat_checkLogin_flag = window.setTimeout(setHeartbeat, 10 * 1000)
      })
    }
    // 判断是否有登录态，决定开启心跳机制
    _t.asyncCheckLogin().then(function (res) {
      // 已登录，存在登录态，立即开启心跳
      setHeartbeat()
    }).catch(function (err) {
      // 初始化时未登录状态，开启一个5分钟的定时任务，轮询登录状态，直到存在登录态时清除任务定时器，正常开启心跳逻辑
      var setCheckLoginTimer_flag = setInterval(function () {
        _t.asyncCheckLogin().then(function (res) {
          // 已登录，存在登录态，清除定时任务setCheckLoginTimer_flag，同时开启正常心跳逻辑
          window.clearInterval(setCheckLoginTimer_flag)
          setHeartbeat()
        }).catch(function (err) {
          // 不存在登录态，不做任何处理
        })
      }, 5 * 60 * 1000)
    })
    // 设置资源错误系统日志
    // _util.sysLog(logHost)
    // 上报设备信息
    // _util.upLoadDeviceInfo(passport_host_v1+ '/web/config/init')
  },
  /*
  * @discribe 用户获取一些header头基本信息的方法
  * @method getNeedInfo
  * @param {Function} 匿名函数方法
  * @return {Object} 返回一个对象
  * */
  getDeviceInfo(params) {
    params.success({
      errcode: 0,
      errmsg: '请求成功',
      data: {
        "d-id": _util.createdDId()
      }
    });
  },
  /**
   * 日志上报
   * @param click_id string
   * @param data object
   * @constructor
   */
  udcWebLog: function (click_id, data = {}) {
    const setInitConfig = {
      env: 'production',
      biz_id: '3f1dc899ed6a336b67e34c483035ca41'
    };
    const talUdcLogJsSDK = new TalUdcLogJSSDK(setInitConfig);
    talUdcLogJsSDK.clickLog({
      'params': {
        click_id: click_id,
        data: data
      }
    });
  },
  /*
  * @discribe 初始化无痕验证。
  * @method configNVC
  * @param {params} 登录参数
  * @return {Boolean} 返回一个Promise对象 startPollingQRCodeStatus
  * */
  configNVC: function (configParams) {
    // 证明调用了滑块
    window.TAL_UC_PASSPORT_CONFIG_NVC_INIT = this.configNVCInit(configParams)
  },
  configNVCInit: function (configParams) {
    var _this = this
    configNVCInitParams = configParams || {}
    console.log(configNVCInitParams, 'configNVCInitParams======')
    return new Promise(function (resolve, reject) {
      if (window.initAliyunCaptcha) {
        // 已经加载过了，直接返回成功
        resolve({ status: 'success' });
        return;
      }
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js'
      document.getElementsByTagName('head')[0].appendChild(script)

      // 添加状态标记，防止超时后资源延迟加载导致重复处理
      var isResolved = false;

      // 清理资源的通用方法
      var cleanup = function() {
        if (script) {
          script.onload = null;
          script.onerror = null;
        }
      };

      // 设置加载超时（10秒）
      var timeoutId = setTimeout(function() {
        if (isResolved) return; // 已处理过，直接返回
        isResolved = true;

        cleanup();
        // 超时后移除未成功加载的 script 标签，防止后续延迟加载
        if (script && script.parentNode) {
          script.parentNode.removeChild(script);
        }

        console.warn('阿里云验证码加载超时，将降级到图形验证码');
        configParams.failCallback && configParams.failCallback();
        resolve({ status: 'fail', reason: 'timeout' });
      }, 10000);

      script.onload = function () {
        if (isResolved) {
          // 已超时处理，不再执行初始化逻辑
          console.warn('阿里云验证码延迟加载成功，但已超时降级，忽略此次加载');
          return;
        }
        isResolved = true;

        clearTimeout(timeoutId);
        cleanup();
        console.log('阿里云验证码加载成功');
        _this.AliCaptchaInit();
        resolve({ status: 'success' });
      };

      script.onerror = function () {
        if (isResolved) return; // 已处理过，直接返回
        isResolved = true;

        clearTimeout(timeoutId);
        cleanup();
        // 加载失败时移除 script 标签
        if (script && script.parentNode) {
          script.parentNode.removeChild(script);
        }

        console.warn('阿里云验证码加载失败，将降级到图形验证码');
        configParams.failCallback && configParams.failCallback();
        resolve({ status: 'fail', reason: 'load error' });
      };
    })
  },
  // 滑块验证成功回调方法
  captchaVerifyCallback: function (captchaVerifyParam) {
    if(sdkCallbackContext && sdkCallbackContext.method){
      // 将阿里滑块验证结果直接传递，captchaVerifyParam 本身就是验证字符串
      var captchaData = captchaVerifyParam ? captchaVerifyParam : null;
      console.log('captchaVerifyCallback - 准备回调方法:', sdkCallbackContext.method, 'captchaData:', captchaData)

      // 使用动态方法调用替代不安全的 eval
      if (typeof this[sdkCallbackContext.method] === 'function') {
        this[sdkCallbackContext.method](sdkCallbackContext.params, captchaData);
      } else {
        console.error('captchaVerifyCallback - 方法不存在:', sdkCallbackContext.method);
      }
    }
  },
  /*
 * @discribe
 * @method AliCaptchaInit
 * @param {params} 登录参数
 * @return {Boolean} 返回一个Promise对象
 * */
  AliCaptchaInit: function () {
    let _this = this;
    let button = document.createElement('button')
    button.id = 'tal-udc-captcha-button-for-aliyun'
    button.className = 'tal-udc-captcha-button'
    button.style.display = 'none'
    document.body.appendChild(button)
    try {
      let ali20Captcha;
      window.initAliyunCaptcha({
        SceneId: '8tvl80fq', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        mode: 'embed', // 无痕滑块只能是嵌入式
        element: configNVCInitParams.renderToEle, //页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        button: '#' + 'tal-udc-captcha-button-for-aliyun', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
        captchaVerifyCallback: (captchaVerifyParam) => {
          // 销毁验证码
          // ali20Captcha.destroyCaptcha()
          _this.captchaVerifyCallback(captchaVerifyParam);
          // 重新初始化滑块
          _this.AliCaptchaInit()
        },
        // 验证码验证不通过回调函数
        fail: function (result) {
        },
        getInstance: (instance) => {
          ali20Captcha = instance
        }, // 绑定验证码实例函数，无需修改
        slideStyle: {
          width: 320,
          height: 40
        }, // 滑块验证码样式，支持自定义宽度和高度，填入数字即可，单位为px
        language: configNVCInitParams.language,
      })
    } catch (error) {
      console.log(error, 'error======')
    }
  },
  /*
  * @discribe 验证当前状态是否可以直接登录，如果可以使用快捷token登录，无需用户输入账号密码
  * @method checkToken
  * @param {params} 登录参数
  * @return {Boolean} 返回一个Promise对象
  * */
  checkToken: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var setParams = {
      data: params.data || {},
      success: function (res) {
        // passport登录成功存在一个开启心跳的标识，存在localStorage本地存储中
        if (res.errcode == 0) {
          _util.resetLocalStorage.setItem("tal-passport-open-heartbeat-tag", true);
        }
        // 调取传递的回调方法
        params.success ? params.success(res) : function (res) { }

      },
      fail: function (fail) {
        params.fail ? params.fail(fail) : function (fail) { }
      },
      complete: function (res) {
        params.complete ? params.complete(res) : function (res) { }
      }
    }
    // 判断Js-Bridge是否存在Tal-Token，如果存在设置Tal-Token字段header头，不存在不设置该字段，执行之前的逻辑，此逻辑针对h5在APP内调用起作用
    var setRequestHeaderArr = []
    if (!window.SET_APP_TAL_TOKEN) {
      // 向app发送获取token的请求
      try {
        window.SET_APP_TAL_TOKEN = window.talAccSDKJSBridge.getTalToken()
      } catch (err) {
        try {
          window.SET_APP_TAL_TOKEN = window.talAccSdk.TALAccSDKGetTalTokenJSMsgHandler('GET_APP_TAL_TOKEN')
        } catch (err) {
          console.log('web网页')
        }
      }
    }
    console.log(window.SET_APP_TAL_TOKEN, '==SET_APP_TAL_TOKEN==')
    // 判断是否在APP下获取到tal-token
    if (window.SET_APP_TAL_TOKEN) {
      setRequestHeaderArr.push({
        fieldName: 'Tal-Token',
        fieldValue: window.SET_APP_TAL_TOKEN || ''
      })
    } else {
      console.log(window.SET_APP_TAL_TOKEN, '====window.4567890======')
    }
    var setSpecialParams = {
      addHeaders: setRequestHeaderArr
    }
    _util.axiosPost(passport_host_v1 + '/web/login/token', setParams, setSpecialParams)
  },

  /*
  * @discribe 验证当前状态是否可以直接登录，如果可以使用快捷token登录，无需用户输入账号密码
  * @method tokenLogin
  * @param {params} 登录参数
  * @return {Boolean} 返回一个Promise对象
  * */
  tokenLogin: function (params) {
    this.checkToken(params)
  },

  /*
  * @discribe 校验登录态
  * @method checkLogin
  * @param {params} 登录参数
  * */
  checkLogin: function (params) {
    if (!_util.validResHeader()) return (params.success ? params.success(_util.getCode(1000000)) : '')
    var privateParams = getParams(params)
    // 判断是否存在本地缓存sessionStorage tal-passport-jssdk-tal-token字段
    var getSessionStorageTalToken = _util.resetSessionStorage.getItem('tal-passport-jssdk-tal-token') || ''
    // console.log(getSessionStorageTalToken,'==getSessionStorageTalToken==')
    if (getSessionStorageTalToken) {
      // 如果存在，则表示已经登录，直接返回errcode为0， errmsg为'您已登录'，不再请求校验登录态接口
      var res = {
        errcode: 0,
        errmsg: '您已登录',
        data: {
          tal_token: getSessionStorageTalToken
        }
      }
      privateParams.success ? privateParams.success(res) : function (res) { }
    } else {
      // 如果不存在，则判断Js-Bridge是否存在，如果存在设置Set-Tal-Token字段header头，不存在不设置该字段，且不管存在与否均需要请求校验登录态接口
      if (!window.SET_APP_TAL_TOKEN) {
        // 向app发送获取token的请求
        try {
          window.SET_APP_TAL_TOKEN = window.talAccSDKJSBridge.getTalToken()
        } catch (err) {
          try {
            window.SET_APP_TAL_TOKEN = window.talAccSdk.TALAccSDKGetTalTokenJSMsgHandler('GET_APP_TAL_TOKEN')
          } catch (err) {
            console.log('web网页')
          }
        }
      }
      var getJsBridgeTalToken = (window.SET_APP_TAL_TOKEN ? window.SET_APP_TAL_TOKEN : '')
      // 设置header头字段数据
      var setRequestHeaderArr = []
      if (getJsBridgeTalToken) {
        setRequestHeaderArr.push({
          fieldName: 'Tal-Token',
          fieldValue: getJsBridgeTalToken || ''
        })
      }
      var setSpecialParams = {
        addHeaders: setRequestHeaderArr
      }
      // 如果不存在Js-Bridge，是在web网页下，接口会主动去校验cookie中的Tal-Token字段，即响应头不存在Tal-Token，就会主动校验cookie中是否存在Tal-Token字段以便校验是否登录
      // 请求校验登录态接口
      _util.axiosPost(cg_host_v1 + '/web/login/status/check', privateParams, setSpecialParams)
    }
  },

  /*
  * @discribe 校验登录态Promise异步请求二次封装
  * @method asyncCheckLogin
  * @param {params} 登录参数
  * @return {Boolean} 返回一个Promise对象
  * */
  asyncCheckLogin: function () {
    var _t = this
    return new Promise(function (resolve, reject) {
      var setParams = {
        success: function (res) {
          // errcode为0代表已登录，否则均为未登录，接口返回什么就是什么
          if (res.errcode == 0) {
            resolve(res)
          } else {
            reject(res)
          }
        },
        fail: function (res) {
          var errInfo = {
            errdata: res,
            errmsg: res.errmsg ? res.errmsg : '网络异常，请刷新重试！'
          }
          reject(errInfo)
        },
        complete: function (res) {
        }
      }
      _t.checkLogin(setParams)
    })
  },

  /*
  * @discribe 展示滑块验证。
  * @method showSlide
  * @param {params} 登录参数
  * @return {Boolean} 返回一个Promise对象
  * */
  showSlide: function () {
    let ali20Captcha, _t = this;
    // 唤醒二次验证（阿里风控2.0滑块模式）初始化阿里滑块
    window.initAliyunCaptcha({
      SceneId: '1atiy64k', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      mode: 'embed', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
      element: configNVCInitParams.renderToEle, //页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      button: '#' + 'tal-udc-captcha-button-for-aliyun', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
      captchaVerifyCallback: (captchaVerifyParam) => {
        _t.captchaVerifyCallback(captchaVerifyParam);
        // 初始化滑块
        _t.AliCaptchaInit()
      },
      fail: function (result) {
        console.error(result,'==2222==result======');
      },
      getInstance: (instance) => {
        ali20Captcha = instance
        // document.getElementById('tal-udc-captcha-button-for-aliyun').click()
      }, // 绑定验证码实例函数，无需修改
      slideStyle: {
        width: 320,
        height: 40
      }, // 滑块验证码样式，支持自定义宽度和高度，填入数字即可，单位为px
      language: configNVCInitParams.language,
      immediate: true,
    })
  },
  /*
  * @discribe 获取初始化数据
  * @method getInitData
  * */
  getInitData: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    _util.axiosGet(passport_host_v1 + '/web/config/init', params)
  },
  /*
  * @discribe 退出登录。
  * @method loginOut
  * @param {params} 参数
  * */
  loginOut: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var setSpecialParams = {
      name: 'loginOut'
    }
    _util.axiosGet(passport_host_v1 + '/web/login/logout', params, setSpecialParams)
  },
  /*
  * @discribe 账号密码登录。
  * @method loginPassword
  * @param {params} 登录参数
  * @return {Boolean} 返回一个Promise对象
  * */
  loginPassword: function (params, captchaData) {
    console.log('loginPassword 被调用, captchaData:', captchaData)

    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params)
    // 验证登录账号不能为空
    if (!_util.validNotEmpty(privateParams.data.symbol)) {
      params.success(_util.getCode(1010000));
      return
    }
    // 验证密码不能为空
    if (!_util.validNotEmpty(privateParams.data.password)) {
      params.success(_util.getCode(1010002));
      return
    }

    var _t = this

    var sendRequest = function (captchaVerifyParam) {
      console.log('loginPassword sendRequest 被调用, captchaVerifyParam:', captchaVerifyParam)
      // 只有当 captchaVerifyParam 是字符串类型时，才认为是阿里无感验证码数据
      // 图形验证码数据是对象类型 {requestType: 1, captchaVal: '...'}
      if (captchaVerifyParam && typeof captchaVerifyParam === 'string') {
        try {
          let captchaVerifyParamObj = JSON.parse(captchaVerifyParam);
          // 确认包含 sceneId 字段，进一步确保是阿里验证码数据
          if (captchaVerifyParamObj && captchaVerifyParamObj.sceneId) {
            privateParams.data.invisible_sig = captchaVerifyParam;
            privateParams.data.invisible_sig_scene = captchaVerifyParamObj.sceneId;
            console.log('loginPassword - 设置阿里无感验证码参数')
          }
        } catch (e) {
          console.warn('loginPassword - 解析验证码参数失败:', e)
        }
      }

      privateParams.data.source_type = 2
      privateParams.data.domain = domain
      console.log('loginPassword 准备发送请求, 请求参数:', privateParams.data)
      // 重置请求参数
      var setParams = {
        data: privateParams.data || {},
        success: function (res) {
          // passport登录成功存在一个开启心跳的标识，存在localStorage本地存储中
          if (res.errcode == 0) {
            _util.resetLocalStorage.setItem("tal-passport-open-heartbeat-tag", true);
          }
          // 调取传递的回调方法
          privateParams.success ? privateParams.success(res) : function (res) { }
        },
        fail: function (fail) {
          privateParams.fail ? privateParams.fail(fail) : function (fail) { }
        },
        complete: function (res) {
          privateParams.complete ? privateParams.complete(res) : function (res) { }
        }
      }
      _util.axiosPost(passport_host_v1 + '/web/login/pwd', setParams)
    }

    // 如果是第二次校验（已经通过滑块验证），直接调用接口
    console.log('loginPassword 判断是否已有验证数据: is_second_verify=', privateParams.data.is_second_verify, 'captchaData=', captchaData)
    if (captchaData) {
      console.log('loginPassword - 已有验证数据，直接发送请求')
      sendRequest(captchaData)
      return
    }

    console.log('loginPassword 未检测到验证数据，准备触发滑块')
    // 判断是否初始化滑块
    if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
      console.log('loginPassword - 开始等待阿里验证码初始化')
      window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function (res) {
        console.log('loginPassword - 阿里验证码初始化完成', res)

        // 检查阿里验证码是否加载成功
        if (res && res.status === 'fail') {
          // 阿里验证码加载失败，降级到图形验证码
          console.log('阿里验证码加载失败，降级使用图形验证码', res.reason)
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'loginPassword',
            requestUrl: '/web/login/pwd',
            sceneType: 3,
            host: passport_host_v1,
            checkToken: false,
            specialParams: {
              isCheckLogin: false
            }
          }, captchaData)
          return;
        }

        // 阿里风控2.0能力调用
        if (window.initAliyunCaptcha) {
          console.log('loginPassword - 触发阿里验证码')
          // 保存上下文，用于滑块成功后回调
          sdkCallbackContext = {
            method: 'loginPassword',
            params: params,
            captchaData: null
          };
          // 触发阿里滑块按钮点击
          document.getElementById('tal-udc-captcha-button-for-aliyun').click()
        } else {
          // 没有 initAliyunCaptcha 方法，使用图形验证码
          console.log('loginPassword - 使用图形验证码')

          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'loginPassword',
            requestUrl: '/web/login/pwd',
            sceneType: 3,
            host: passport_host_v1,
            checkToken: false,
            specialParams: {
              isCheckLogin: false
            }
          }, captchaData)
        }
      }).catch(function(err) {
        // Promise 异常，降级到图形验证码
        console.error('阿里验证码初始化异常，降级使用图形验证码', err)
        captchaData = captchaData || {}
        _t.captchaSendFn(privateParams, {
          requestName: 'loginPassword',
          requestUrl: '/web/login/pwd',
          sceneType: 3,
          host: passport_host_v1,
          checkToken: false,
          specialParams: {
            isCheckLogin: false
          }
        }, captchaData)
      })
    } else {
      // 没有初始化滑块，直接发送请求
      console.log('loginPassword 没有初始化滑块配置，直接发送请求')
      sendRequest()
    }
  },
  /*
 * @discribe 手机号验证码登录。
 * @method loginSms
 * @param {params} 登录参数
 * @return {Boolean} 返回一个Promise对象
 * */
  loginSms: function (params, captchaData) {
    console.log('loginSms 被调用, captchaData:', captchaData)

    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params)
    privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
    // 验证手机号为空
    if (!_util.validNotEmpty(privateParams.data.phone)) {
      params.success(_util.getCode(1010006));
      return
    }
    // 验证手机号合法性
    if (!_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
      params.success(_util.getCode(1010007));
      return
    }
    // 验证手机验证码为空
    if (!_util.validNotEmpty(privateParams.data.sms_code)) {
      params.success(_util.getCode(1010008));
      return
    }
    // 验证手机号验证码合法性
    if (!_util.validVCode(privateParams.data.sms_code)) {
      params.success(_util.getCode(1010001));
      return
    }
    var _t = this, _loginRequestUrl = "/web/login/sms";
    var urlParams = _util.getUrlParmas(window.location.href);
    if (urlParams.__udc_ctx) {
      __udc_ctx = urlParams.__udc_ctx;
    }
    if (privateParams.data.bindType == 1) {
      // 区分是微信登录还是普通登录,bindType为1是微信授权登录接口
      privateParams.data['ctx'] = __udc_ctx || ''
      _loginRequestUrl = '/web/wx/login/sms'
    } else if (privateParams.data.bindType == 2) {
      // 区分是微信换绑登录,bindType为2是微信换绑登录接口
      _loginRequestUrl = '/web/wx/switch/sms'
    }

    var sendRequest = function (captchaVerifyParam) {
      console.log('loginSms sendRequest 被调用, captchaVerifyParam:', captchaVerifyParam)
      // 只有当 captchaVerifyParam 是字符串类型时，才认为是阿里无感验证码数据
      // 图形验证码数据是对象类型 {requestType: 1, captchaVal: '...'}
      if (captchaVerifyParam && typeof captchaVerifyParam === 'string') {
        try {
          let captchaVerifyParamObj = JSON.parse(captchaVerifyParam);
          // 确认包含 sceneId 字段，进一步确保是阿里验证码数据
          if (captchaVerifyParamObj && captchaVerifyParamObj.sceneId) {
            privateParams.data.invisible_sig = captchaVerifyParam;
            privateParams.data.invisible_sig_scene = captchaVerifyParamObj.sceneId;
            console.log('loginSms - 设置阿里无感验证码参数')
          }
        } catch (e) {
          console.warn('loginSms - 解析验证码参数失败:', e)
        }
      }

      privateParams.data.source_type = 2
      privateParams.data.domain = domain
      console.log('loginSms 准备发送请求, 请求参数:', privateParams.data)
      // 重置请求参数
      var setParams = {
        data: privateParams.data || {},
        success: function (res) {
          // passport登录成功存在一个开启心跳的标识，存在localStorage本地存储中
          if (res.errcode == 0) {
            _util.resetLocalStorage.setItem("tal-passport-open-heartbeat-tag", true);
          }
          // 调取传递的回调方法
          privateParams.success ? privateParams.success(res) : function (res) { }
        },
        fail: function (fail) {
          privateParams.fail ? privateParams.fail(fail) : function (fail) { }
        },
        complete: function (res) {
          privateParams.complete ? privateParams.complete(res) : function (res) { }
        }
      }
      _util.axiosPost(passport_host_v1 + _loginRequestUrl, setParams)
    }

    // 如果是第二次校验（已经通过滑块验证），直接调用接口
    console.log('loginSms 判断是否已有验证数据: is_second_verify=', privateParams.data.is_second_verify, 'captchaData=', captchaData)
    if (captchaData) {
      console.log('loginSms - 已有验证数据，直接发送请求')
      sendRequest(captchaData)
      return
    }

    console.log('loginSms 未检测到验证数据，准备触发滑块')
    // 判断是否初始化滑块
    if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
      console.log('loginSms - 开始等待阿里验证码初始化')
      window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function (res) {
        console.log('loginSms - 阿里验证码初始化完成', res)

        // 检查阿里验证码是否加载成功
        if (res && res.status === 'fail') {
          // 阿里验证码加载失败，降级到图形验证码
          console.log('阿里验证码加载失败，降级使用图形验证码', res.reason)
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'loginSms',
            requestUrl: _loginRequestUrl,
            sceneType: 2,
            host: passport_host_v1,
            checkToken: false,
            specialParams: {
              isCheckLogin: false
            }
          }, captchaData)
          return;
        }

        // 阿里风控2.0能力调用
        if (window.initAliyunCaptcha) {
          console.log('loginSms - 触发阿里验证码')
          // 保存上下文，用于滑块成功后回调
          sdkCallbackContext = {
            method: 'loginSms',
            params: params,
            captchaData: null
          };
          // 触发阿里滑块按钮点击
          document.getElementById('tal-udc-captcha-button-for-aliyun').click()
        } else {
          // 没有 initAliyunCaptcha 方法，使用图形验证码
          console.log('loginSms - 使用图形验证码')

          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'loginSms',
            requestUrl: _loginRequestUrl,
            sceneType: 2,
            host: passport_host_v1,
            checkToken: false,
            specialParams: {
              isCheckLogin: false
            }
          }, captchaData)
        }
      }).catch(function(err) {
        // Promise 异常，降级到图形验证码
        console.error('阿里验证码初始化异常，降级使用图形验证码', err)
        captchaData = captchaData || {}
        _t.captchaSendFn(privateParams, {
          requestName: 'loginSms',
          requestUrl: _loginRequestUrl,
          sceneType: 2,
          host: passport_host_v1,
          checkToken: false,
          specialParams: {
            isCheckLogin: false
          }
        }, captchaData)
      })
    } else {
      // 没有初始化滑块，直接发送请求
      console.log('loginSms 没有初始化滑块配置，直接发送请求')
      sendRequest()
    }
  },
  /*
  * @discribe 登录获取手机验证码（阿里2.0风控
  * @method sendSMSCodeLogin
  * @param {Object} params  请求参数 参数 type: 0 登录 1 找回密码 2 设置密码
  * @param {Object} captchaData 图形验证场景的数据传参
  * */
  sendSMSCodeLogin: function (params, captchaData) {
    console.log('sendSMSCodeLogin 被调用, captchaData:', captchaData)

    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))

    var privateParams = getParams(params)
    privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'

    // 验证手机号为空
    if (!_util.validNotEmpty(privateParams.data.phone)) {
      params.success(_util.getCode(1010006));
      return
    }
    // 验证手机号合法性
    if (!_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
      params.success(_util.getCode(1010007));
      return
    }

    var _t = this,
      _smsRequestUrl = '/web/login/sms/send';
    var urlParams = _util.getUrlParmas(window.location.href);
    if (urlParams.__udc_ctx) {
      __udc_ctx = urlParams.__udc_ctx;
    }
    if (privateParams.data.bindType == 1) {
      // 区分是微信登录还是普通登录获取验证码,bindType为1是微信授权登录获取验证码接口
      privateParams.data['ctx'] = __udc_ctx || ''
      _smsRequestUrl = '/web/wx/login/sms/send'
    } else if (privateParams.data.bindType == 2) {
      _smsRequestUrl = '/web/wx/switch/sms/send'
    }

    var set_host = passport_host_v1
    var is_token = false
    // use 为5、6、7时需要登录态，4找回密码不需要登录态
    if (privateParams.data && (privateParams.data.use == 5 || privateParams.data.use == 6 || privateParams.data.use == 7)) {
      set_host = cg_host_v1
      is_token = true
    }
    // 设置需要登录态的特殊参数
    var setSpecialParams = {
      isCheckLogin: true,
      name: 'sendSMSCodeLogin'
    }

    var sendRequest = function (captchaVerifyParam) {
      console.log('sendRequest 被调用, captchaVerifyParam:', captchaVerifyParam)
      // 只有当 captchaVerifyParam 是字符串类型时，才认为是阿里无感验证码数据
      // 图形验证码数据是对象类型 {requestType: 1, captchaVal: '...'}
      if (captchaVerifyParam && typeof captchaVerifyParam === 'string') {
        try {
          let captchaVerifyParamObj = JSON.parse(captchaVerifyParam);
          // 确认包含 sceneId 字段，进一步确保是阿里验证码数据
          if (captchaVerifyParamObj && captchaVerifyParamObj.sceneId) {
            privateParams.data.invisible_sig = captchaVerifyParam;
            privateParams.data.invisible_sig_scene = captchaVerifyParamObj.sceneId;
            console.log('sendSMSCodeLogin - 设置阿里无感验证码参数')
          }
        } catch (e) {
          console.warn('sendSMSCodeLogin - 解析验证码参数失败:', e)
        }
      }
      console.log('准备发送请求, 请求参数:', privateParams.data)
      if (is_token) {
        _t.asyncCheckLogin().then(function (res) {
          _util.axiosPost(set_host + _smsRequestUrl, privateParams, setSpecialParams)
        }).catch(function (fail) {
          // 未登录，接口返回什么就是什么，原封不动返回给业务方
          if (fail.errcode) {
            params.success ? params.success(fail) : function (fail) { }
          } else {
            params.fail ? params.fail(fail) : function (fail) { }
          }
          params.complete ? params.complete(fail) : function (fail) { }
        })
      } else {
        _util.axiosPost(set_host + _smsRequestUrl, privateParams)
      }
    }

    // 如果是第二次校验（已经通过滑块验证），直接调用接口
    console.log('判断是否已有验证数据: is_second_verify=', privateParams.data.is_second_verify, 'captchaData=', captchaData)
    if (captchaData) {
      console.log('sendSMSCodeLogin - 已有验证数据，直接发送请求')
      sendRequest(captchaData)
      return
    }

    console.log('未检测到验证数据，准备触发滑块')
    // 判断是否初始化滑块
    if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
      console.log('sendSMSCodeLogin - 开始等待阿里验证码初始化')
      window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function (res) {
        console.log('sendSMSCodeLogin - 阿里验证码初始化完成', res)

        // 检查阿里验证码是否加载成功
        if (res && res.status === 'fail') {
          // 阿里验证码加载失败，降级到图形验证码
          console.log('阿里验证码加载失败，降级使用图形验证码', res.reason)
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'sendSMSCodeLogin',
            requestUrl: _smsRequestUrl,
            sceneType: 1,
            host: set_host,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
          return;
        }

        // 阿里风控2.0能力调用
        if (window.initAliyunCaptcha) {
          console.log('sendSMSCodeLogin - 触发阿里验证码')
          // 保存上下文，用于滑块成功后回调
          sdkCallbackContext = {
            method: 'sendSMSCodeLogin',
            params: params,
            captchaData: null
          };
          // 触发阿里滑块按钮点击
          document.getElementById('tal-udc-captcha-button-for-aliyun').click()
          console.log('sendSMSCodeLogin - 触发阿里验证码成功=====并点击了按钮')
        } else {
          // 没有 initAliyunCaptcha 方法，使用图形验证码
          console.log('sendSMSCodeLogin - 使用图形验证码')
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'sendSMSCodeLogin',
            requestUrl: _smsRequestUrl,
            sceneType: 1,
            host: set_host,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
        }
      }).catch(function(err) {
        // Promise 异常，降级到图形验证码
        console.error('阿里验证码初始化异常，降级使用图形验证码', err)
        captchaData = captchaData || {}
        _t.captchaSendFn(privateParams, {
          requestName: 'sendSMSCodeLogin',
          requestUrl: _smsRequestUrl,
          sceneType: 1,
          host: set_host,
          checkToken: is_token,
          specialParams: setSpecialParams
        }, captchaData)
      })
    } else {
      // 没有初始化滑块，直接发送请求
      console.log('没有初始化滑块配置，直接发送请求')
      sendRequest()
    }
  },
  /*
  * @discribe 密码、手机号修改获取验证码。
  * @method sendSMSCode
  * @param {params} 参数 type: 0 登录 1 找回密码 2 设置密码
  * @return {Boolean} 返回一个Promise对象
  * */
  sendSMSCode: function (params, captchaData) {
    console.log('sendSMSCode 被调用, captchaData:', captchaData)

    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))

    var privateParams = getParams(params)
    privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
    // 验证手机号为空
    if ((privateParams.data.use == 4 || privateParams.data.use == 7) && !_util.validNotEmpty(privateParams.data.phone)) {
      params.success(_util.getCode(1010012))
      return
    }
    // 验证手机号合法性
    if ((privateParams.data.use == 4 || privateParams.data.use == 7) && !_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
      params.success(_util.getCode(1010011))
      return
    }

    var _t = this;
    var set_host = passport_host_v1
    var is_token = false
    // use 为5、6、7时需要登录态，4找回密码不需要登录态
    if (privateParams.data && (privateParams.data.use == 5 || privateParams.data.use == 6 || privateParams.data.use == 7)) {
      set_host = cg_host_v1
      is_token = true
    }
    // 设置需要登录态的特殊参数
    var setSpecialParams = {
      isCheckLogin: true,
      name: 'sendSMSCode'
    }

    var sendRequest = function (captchaVerifyParam) {
      console.log('sendSMSCode sendRequest 被调用, captchaVerifyParam:', captchaVerifyParam)
      // 只有当 captchaVerifyParam 是字符串类型时，才认为是阿里无感验证码数据
      // 图形验证码数据是对象类型 {requestType: 1, captchaVal: '...'}
      if (captchaVerifyParam && typeof captchaVerifyParam === 'string') {
        try {
          let captchaVerifyParamObj = JSON.parse(captchaVerifyParam);
          // 确认包含 sceneId 字段，进一步确保是阿里验证码数据
          if (captchaVerifyParamObj && captchaVerifyParamObj.sceneId) {
            privateParams.data.invisible_sig = captchaVerifyParam;
            privateParams.data.invisible_sig_scene = captchaVerifyParamObj.sceneId;
            console.log('sendSMSCode - 设置阿里无感验证码参数')
          }
        } catch (e) {
          console.warn('sendSMSCode - 解析验证码参数失败:', e)
        }
      }
      console.log('sendSMSCode 准备发送请求, 请求参数:', privateParams.data)
      if (is_token) {
        _t.asyncCheckLogin().then(function (res) {
          _util.axiosPost(set_host + '/web/security/sms', privateParams, setSpecialParams)
        }).catch(function (fail) {
          // 未登录，接口返回什么就是什么，原封不动返回给业务方
          if (fail.errcode) {
            params.success ? params.success(fail) : function (fail) { }
          } else {
            params.fail ? params.fail(fail) : function (fail) { }
          }
          params.complete ? params.complete(fail) : function (fail) { }
        })
      } else {
        _util.axiosPost(set_host + '/web/security/sms', privateParams)
      }
    }

    // 如果是第二次校验（已经通过滑块验证），直接调用接口
    console.log('sendSMSCode 判断是否已有验证数据: is_second_verify=', privateParams.data.is_second_verify, 'captchaData=', captchaData)
    if (captchaData) {
      console.log('sendSMSCode - 已有验证数据，直接发送请求')
      sendRequest(captchaData)
      return
    }

    console.log('sendSMSCode 未检测到验证数据，准备触发滑块')
    // 判断是否初始化滑块
    if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
      console.log('sendSMSCode - 开始等待阿里验证码初始化')
      window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function (res) {
        console.log('sendSMSCode - 阿里验证码初始化完成', res)

        // 检查阿里验证码是否加载成功
        if (res && res.status === 'fail') {
          // 阿里验证码加载失败，降级到图形验证码
          console.log('阿里验证码加载失败，降级使用图形验证码', res.reason)
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'sendSMSCode',
            requestUrl: '/web/security/sms',
            sceneType: 4,
            host: set_host,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
          return;
        }

        // 阿里风控2.0能力调用
        if (window.initAliyunCaptcha) {
          console.log('sendSMSCode - 触发阿里验证码')
          // 保存上下文，用于滑块成功后回调
          sdkCallbackContext = {
            method: 'sendSMSCode',
            params: params,
            captchaData: null
          };
          // 触发阿里滑块按钮点击
          document.getElementById('tal-udc-captcha-button-for-aliyun').click()
          console.log('sendSMSCode - 触发阿里验证码成功=====并点击了按钮')
        } else {
          // 没有 initAliyunCaptcha 方法，使用图形验证码
          console.log('sendSMSCode - 使用图形验证码')
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'sendSMSCode',
            requestUrl: '/web/security/sms',
            sceneType: 4,
            host: set_host,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
        }
      }).catch(function(err) {
        // Promise 异常，降级到图形验证码
        console.error('阿里验证码初始化异常，降级使用图形验证码', err)
        captchaData = captchaData || {}
        _t.captchaSendFn(privateParams, {
          requestName: 'sendSMSCode',
          requestUrl: '/web/security/sms',
          sceneType: 4,
          host: set_host,
          checkToken: is_token,
          specialParams: setSpecialParams
        }, captchaData)
      })
    } else {
      // 没有初始化滑块，直接发送请求
      console.log('sendSMSCode 没有初始化滑块配置，直接发送请求')
      sendRequest()
    }
  },
  /*
 * @discribe 获取手机号地区码、仅支持大陆和香港
 * @method getPhoneCodeList
 * @param {params} 参数
 * @return {Boolean} 返回一个Promise对象
 * */
  getPhoneCodeList: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params)
    _util.axiosPost(passport_host_v1 + '/web/phonecode/get', privateParams)
  },

  /*
  * @discribe 获取手机号国家码表（支持海外手机号）
  * @method getAllPhoneCodeList
  * @param {params} 参数
  * */
  getAllPhoneCodeList: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params)
    _util.axiosPost(passport_host_v1 + '/web/phonecode/foreign/get', privateParams)
  },

  /*
 * @discribe 获取是否绑定手机号和设置密码。
 * @method getSafeInfo
 * @param {params} 参数
 * @return {Boolean} 返回一个Promise对象
 * */
  getSafeInfo: function (params) {
    var privateParams = getParams(params)
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    this.asyncCheckLogin().then(function (res) {
      var setSpecialParams = {
        isCheckLogin: true,
        name: 'getSafeInfo'
      }
      _util.axiosGet(cg_host_v1 + '/web/security/info', privateParams, setSpecialParams)
    }).catch(function (fail) {
      // 未登录，接口返回什么就是什么，原封不动返回给业务方
      if (fail.errcode) {
        params.success ? params.success(fail) : function (fail) { }
      } else {
        params.fail ? params.fail(fail) : function (fail) { }
      }
      params.complete ? params.complete(fail) : function (fail) { }
    })

  },
  /*
 * @discribe 获取用户主标识。
 * @method getSafeInfo
 * @param {params} 参数
 * @return {Boolean} 返回一个Promise对象
 * */
  getMainSymbol: function (params) {
    var privateParams = getParams(params)
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    _util.axiosGet(passport_host_v1 + '/web/acct/symbol', privateParams)
  },
  /*
 * @discribe 忘记密码，验证旧手机
 * @method checkPhone
 * @param {params} 参数
 * @return {Boolean} 返回一个Promise对象
 * */
  checkPhone: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params)
    // 验证类型不能为空
    if (!privateParams.data.type) {
      return params.success(_util.getCode(1010005))
    }
    if (privateParams.data.type == 4) {
      // 忘记密码
      privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
      // 验证手机号为空
      if (!_util.validNotEmpty(privateParams.data.phone)) {
        params.success(_util.getCode(1010012));
        return
      }
      // 验证手机号合法性
      if (!_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
        params.success(_util.getCode(1010011));
        return
      }
    }
    // 验证验证码为空
    if (!_util.validNotEmpty(privateParams.data.vcode)) {
      params.success(_util.getCode(1010009));
      return
    }
    // 验证合法性
    if (!_util.validVCode(privateParams.data.vcode)) {
      params.success(_util.getCode(1010013));
      return
    }
    if (privateParams.data.is_second_verify != 1 && window.ALI_AWSC_INIT_NVC && typeof window.ALI_AWSC_INIT_NVC.getNVCVal === 'function') {
      // 非二次滑块验证，拼接无痕验证签名
      privateParams.data.invisible_sig = window.ALI_AWSC_INIT_NVC.getNVCVal()
    }
    // 判断是否需要登录态
    if (privateParams.data.type == 5 || privateParams.data.type == 6) {
      // 换绑手机号和登录态下修改密码，需要登录态
      var setSpecialParams = {
        isCheckLogin: true,
        name: 'checkPhone'
      }
      this.asyncCheckLogin().then(function (res) {
        _util.axiosPost(cg_host_v1 + '/web/security/cellphone/check', privateParams, setSpecialParams)
      }).catch(function (fail) {
        // 未登录，接口返回什么就是什么，原封不动返回给业务方
        if (fail.errcode) {
          params.success ? params.success(fail) : function (fail) { }
        } else {
          params.fail ? params.fail(fail) : function (fail) { }
        }
        params.complete ? params.complete(fail) : function (fail) { }
      })
    } else {
      // 忘记密码，不需要登录态
      _util.axiosPost(passport_host_v1 + '/web/security/cellphone/check', privateParams)
    }
  },
  /*
  * @discribe 设置密码
  * @method setPassword
  * @param {params} 参数
  * @return {Boolean} 返回一个Promise对象
  * @TODO
  * */
  setPassword: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params)
    if (privateParams.data.phone) {
      privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
    }
    // 验证密码为空
    if (!_util.validNotEmpty(privateParams.data.password)) {
      params.success(_util.getCode(1010014));
      return
    }
    // 验证密码合法性
    if (!_util.validPwd(privateParams.data.password)) {
      params.success(_util.getCode(1010015));
      return
    }
    // 验证手机号为空
    if (privateParams.data.type == 1 && !_util.validNotEmpty(privateParams.data.phone)) {
      params.success(_util.getCode(1010012));
      return
    }
    // 验证邮箱为空
    if (privateParams.data.type == 8 && !_util.validNotEmpty(privateParams.data.email)) {
      params.success(_util.getCode(1010017));
      return
    }
    // 验证手机号合法性
    if (privateParams.data.type == 1 && !_util.validPhone(privateParams.data.phone)) {
      params.success(_util.getCode(1010011));
      return
    }
    // 判断是否需要登录态
    if (privateParams.data.type == 2) {
      // 修改密码，需要登录态
      this.asyncCheckLogin().then(function (res) {
        var setSpecialParams = {
          isCheckLogin: true,
          name: 'setPassword'
        }
        _util.axiosPost(cg_host_v1 + '/web/security/password/set', privateParams, setSpecialParams)
      }).catch(function (fail) {
        // 未登录，接口返回什么就是什么，原封不动返回给业务方
        if (fail.errcode) {
          params.success ? params.success(fail) : function (fail) { }
        } else {
          params.fail ? params.fail(fail) : function (fail) { }
        }
        params.complete ? params.complete(fail) : function (fail) { }
      })
    } else {
      // 忘记密码，不需要登录态
      _util.axiosPost(passport_host_v1 + '/web/security/password/set', privateParams)
    }
  },
  /*
  * @discribe 新绑手机号（阿里验证码2.0风控）
  * @method setPhone
  * @param {params} 参数
  * @param {Object} captchaData 图形验证场景的数据传参
  * @return {Boolean} 返回一个Promise对象
  * @TODO
  * */
  setPhone: function (params, captchaData) {
    console.log('setPhone 被调用, captchaData:', captchaData)

    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))

    var privateParams = getParams(params);
    privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
    // 验证手机号为空
    if (!_util.validNotEmpty(privateParams.data.phone)) {
      params.success(_util.getCode(1010012));
      return
    }
    // 验证手机号合法性
    if (!_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
      params.success(_util.getCode(1010011));
      return
    }
    // 验证验证码为空
    if (!_util.validNotEmpty(privateParams.data.vcode)) {
      params.success(_util.getCode(1010009));
      return
    }
    // 验证验证码合法性
    if (!_util.validVCode(privateParams.data.vcode)) {
      params.success(_util.getCode(1010013));
      return
    }

    var _t = this;
    var set_host = cg_host_v1;
    var is_token = true; // setPhone 需要登录态
    // 设置需要登录态的特殊参数
    var setSpecialParams = {
      isCheckLogin: true,
      name: 'setPhone'
    }

    var sendRequest = function (captchaVerifyParam) {
      console.log('setPhone sendRequest 被调用, captchaVerifyParam:', captchaVerifyParam)
      // 只有当 captchaVerifyParam 是字符串类型时，才认为是阿里无感验证码数据
      // 图形验证码数据是对象类型 {requestType: 1, captchaVal: '...'}
      if (captchaVerifyParam && typeof captchaVerifyParam === 'string') {
        try {
          let captchaVerifyParamObj = JSON.parse(captchaVerifyParam);
          // 确认包含 sceneId 字段，进一步确保是阿里验证码数据
          if (captchaVerifyParamObj && captchaVerifyParamObj.sceneId) {
            privateParams.data.invisible_sig = captchaVerifyParam;
            privateParams.data.invisible_sig_scene = captchaVerifyParamObj.sceneId;
            console.log('setPhone - 设置阿里无感验证码参数')
          }
        } catch (e) {
          console.warn('setPhone - 解析验证码参数失败:', e)
        }
      }
      console.log('setPhone 准备发送请求, 请求参数:', privateParams.data)

      _t.asyncCheckLogin().then(function (res) {
        _util.axiosPost(set_host + '/web/security/cellphone/set', privateParams, setSpecialParams)
      }).catch(function (fail) {
        // 未登录，接口返回什么就是什么，原封不动返回给业务方
        if (fail.errcode) {
          params.success ? params.success(fail) : function (fail) { }
        } else {
          params.fail ? params.fail(fail) : function (fail) { }
        }
        params.complete ? params.complete(fail) : function (fail) { }
      })
    }

    // 如果是第二次校验（已经通过滑块验证），直接调用接口
    console.log('setPhone 判断是否已有验证数据: is_second_verify=', privateParams.data.is_second_verify, 'captchaData=', captchaData)
    if (captchaData) {
      console.log('setPhone - 已有验证数据，直接发送请求')
      sendRequest(captchaData)
      return
    }

    console.log('setPhone 未检测到验证数据，准备触发滑块')
    // 判断是否初始化滑块
    if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
      console.log('setPhone - 开始等待阿里验证码初始化')
      window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function (res) {
        console.log('setPhone - 阿里验证码初始化完成', res)

        // 检查阿里验证码是否加载成功
        if (res && res.status === 'fail') {
          // 阿里验证码加载失败，降级到图形验证码
          console.log('阿里验证码加载失败，降级使用图形验证码', res.reason)
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'setPhone',
            requestUrl: '/web/security/cellphone/set',
            sceneType: 5,
            host: set_host,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
          return;
        }

        // 阿里风控2.0能力调用
        if (window.initAliyunCaptcha) {
          console.log('setPhone - 触发阿里验证码')
          // 保存上下文，用于滑块成功后回调
          sdkCallbackContext = {
            method: 'setPhone',
            params: params,
            captchaData: null
          };
          // 触发阿里滑块按钮点击
          document.getElementById('tal-udc-captcha-button-for-aliyun').click()
          console.log('setPhone - 触发阿里验证码成功=====并点击了按钮')
        } else {
          // 没有 initAliyunCaptcha 方法，使用图形验证码
          console.log('setPhone - 使用图形验证码')
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'setPhone',
            requestUrl: '/web/security/cellphone/set',
            sceneType: 5,
            host: set_host,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
        }
      }).catch(function(err) {
        // Promise 异常，降级到图形验证码
        console.error('阿里验证码初始化异常，降级使用图形验证码', err)
        captchaData = captchaData || {}
        _t.captchaSendFn(privateParams, {
          requestName: 'setPhone',
          requestUrl: '/web/security/cellphone/set',
          sceneType: 5,
          host: set_host,
          checkToken: is_token,
          specialParams: setSpecialParams
        }, captchaData)
      })
    } else {
      // 没有初始化滑块，直接发送请求
      console.log('setPhone 没有初始化滑块配置，直接发送请求')
      sendRequest()
    }
  },
  /*
  * @discribe 换绑手机号（阿里验证码2.0风控）
  * @method changePhone
  * @param {params} 参数
  * @param {Object} captchaData 图形验证场景的数据传参
  * @return {Boolean} 返回一个Promise对象
  * @TODO
  * */
  changePhone: function (params, captchaData) {
    console.log('changePhone 被调用, captchaData:', captchaData)

    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))

    var privateParams = getParams(params);
    privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
    // 验证手机号为空
    if (!_util.validNotEmpty(privateParams.data.phone)) {
      params.success(_util.getCode(1010012));
      return
    }
    // 验证手机号合法性
    if (!_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
      params.success(_util.getCode(1010011));
      return
    }
    // 验证验证码为空
    if (!_util.validNotEmpty(privateParams.data.vcode)) {
      params.success(_util.getCode(1010009));
      return
    }
    // 验证验证码合法性
    if (!_util.validVCode(privateParams.data.vcode)) {
      params.success(_util.getCode(1010016));
      return
    }
    // 验证TAG不能为空
    if (!_util.validNotEmpty(privateParams.data.tag)) {
      params.success(_util.getCode(1010003));
      return
    }

    var _t = this;
    var set_host = cg_host_v1;
    var is_token = true; // changePhone 需要登录态
    // 设置需要登录态的特殊参数
    var setSpecialParams = {
      isCheckLogin: true,
      name: 'changePhone'
    }

    var sendRequest = function (captchaVerifyParam) {
      console.log('changePhone sendRequest 被调用, captchaVerifyParam:', captchaVerifyParam)
      // 只有当 captchaVerifyParam 是字符串类型时，才认为是阿里无感验证码数据
      // 图形验证码数据是对象类型 {requestType: 1, captchaVal: '...'}
      if (captchaVerifyParam && typeof captchaVerifyParam === 'string') {
        try {
          let captchaVerifyParamObj = JSON.parse(captchaVerifyParam);
          // 确认包含 sceneId 字段，进一步确保是阿里验证码数据
          if (captchaVerifyParamObj && captchaVerifyParamObj.sceneId) {
            privateParams.data.invisible_sig = captchaVerifyParam;
            privateParams.data.invisible_sig_scene = captchaVerifyParamObj.sceneId;
            console.log('changePhone - 设置阿里无感验证码参数')
          }
        } catch (e) {
          console.warn('changePhone - 解析验证码参数失败:', e)
        }
      }
      console.log('changePhone 准备发送请求, 请求参数:', privateParams.data)

      _t.asyncCheckLogin().then(function (res) {
        _util.axiosPost(set_host + '/web/security/cellphone/update', privateParams, setSpecialParams)
      }).catch(function (fail) {
        // 未登录，接口返回什么就是什么，原封不动返回给业务方
        if (fail.errcode) {
          params.success ? params.success(fail) : function (fail) { }
        } else {
          params.fail ? params.fail(fail) : function (fail) { }
        }
        params.complete ? params.complete(fail) : function (fail) { }
      })
    }

    // 如果是第二次校验（已经通过滑块验证），直接调用接口
    console.log('changePhone 判断是否已有验证数据: is_second_verify=', privateParams.data.is_second_verify, 'captchaData=', captchaData)
    if (captchaData) {
      console.log('changePhone - 已有验证数据，直接发送请求')
      sendRequest(captchaData)
      return
    }

    console.log('changePhone 未检测到验证数据，准备触发滑块')
    // 判断是否初始化滑块
    if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
      console.log('changePhone - 开始等待阿里验证码初始化')
      window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function (res) {
        console.log('changePhone - 阿里验证码初始化完成', res)

        // 检查阿里验证码是否加载成功
        if (res && res.status === 'fail') {
          // 阿里验证码加载失败，降级到图形验证码
          console.log('阿里验证码加载失败，降级使用图形验证码', res.reason)
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'changePhone',
            requestUrl: '/web/security/cellphone/update',
            sceneType: 6,
            host: set_host,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
          return;
        }

        // 阿里风控2.0能力调用
        if (window.initAliyunCaptcha) {
          console.log('changePhone - 触发阿里验证码')
          // 保存上下文，用于滑块成功后回调
          sdkCallbackContext = {
            method: 'changePhone',
            params: params,
            captchaData: null
          };
          // 触发阿里滑块按钮点击
          document.getElementById('tal-udc-captcha-button-for-aliyun').click()
          console.log('changePhone - 触发阿里验证码成功=====并点击了按钮')
        } else {
          // 没有 initAliyunCaptcha 方法，使用图形验证码
          console.log('changePhone - 使用图形验证码')
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'changePhone',
            requestUrl: '/web/security/cellphone/update',
            sceneType: 6,
            host: set_host,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
        }
      }).catch(function(err) {
        // Promise 异常，降级到图形验证码
        console.error('阿里验证码初始化异常，降级使用图形验证码', err)
        captchaData = captchaData || {}
        _t.captchaSendFn(privateParams, {
          requestName: 'changePhone',
          requestUrl: '/web/security/cellphone/update',
          sceneType: 6,
          host: set_host,
          checkToken: is_token,
          specialParams: setSpecialParams
        }, captchaData)
      })
    } else {
      // 没有初始化滑块，直接发送请求
      console.log('changePhone 没有初始化滑块配置，直接发送请求')
      sendRequest()
    }
  },
  /********* 用户信息相关 ********/
  /*
  * @discribe 获取用户信息
  * @method detailUser
  * @param {params} 参数
  * @return {Boolean} 返回一个Promise对象
  * */
  detailUser: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    this.asyncCheckLogin().then(function (res) {
      var setSpecialParams = {
        isCheckLogin: true,
        name: 'detailUser'
      }
      _util.axiosGet(cg_host_v1 + '/web/user/info', getParams(params), setSpecialParams)
    }).catch(function (fail) {
      // 未登录，接口返回什么就是什么，原封不动返回给业务方
      if (fail.errcode) {
        params.success ? params.success(fail) : function (fail) { }
      } else {
        params.fail ? params.fail(fail) : function (fail) { }
      }
      params.complete ? params.complete(fail) : function (fail) { }
    })
  },
  /*
  * @discribe 修改用户信息
  * @method modifyUserInfo
  * @param {params} 参数
  * @return {Boolean} 返回一个Promise对象
  * */
  modifyUserInfo: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    // 判断是v1还是v2
    var new_host = cg_host_v1
    if (params.data.version) {
      new_host = cg_host_v2 + '/' + params.data.version
      delete params.data.version
    }
    var privateParams = getParams(params);
    var pattern = new RegExp("[`~!@#$%^&*()_\\-+=<>?:\"{}|,.\\/;'\\\\[\\]·~！@#￥%……&*（）——\\-+={}|《》？：“” 【】、；‘’，。、]", 'g');
    // 通行证验证
    if (privateParams.data.tal_name !== undefined) {
      if (pattern.test(privateParams.data.tal_name)) {
        return params.success(_util.getCode(1020000))
      }
      if (!/^[0-9a-zA-Z]{8,16}$/.test(privateParams.data.tal_name)) {
        return params.success(_util.getCode(1020000))
      }
      if (/^\d+$/.test(privateParams.data.tal_name)) {
        return params.success(_util.getCode(1020000))
      }
    }
    // 昵称验证
    if (privateParams.data.nickname !== undefined) {
      if (pattern.test(privateParams.data.nickname)) {
        return params.success(_util.getCode(1020001))
      }
      if (privateParams.data.nickname.length > 32) {
        return params.success(_util.getCode(1020001))
      }
      if (_util.validEmpty(privateParams.data.nickname)) {
        return params.success(_util.getCode(1020001))
      }
    }
    // 真实姓名验证
    if (privateParams.realname !== undefined) {
      // var regName = /^[a-z0-9A-Z&\-,（）(). \u4e00-\u9fa5]+$/;
      // if (!regName.test(privateParams.data.realname)) {
      //     return params.success(_util.getCode(1020002))
      // }
      /*验证32位*/
      // if (privateParams.data.realname.length > 32) {
      //     return params.success(_util.getCode(1020002))
      // }
      if (_util.validEmpty(privateParams.data.realname)) {
        return params.success(_util.getCode(1020002))
      }
    }
    // 英文名验证
    /*k可以多位空格*/
    if (privateParams.data.en_name !== undefined) {
      var enreg = /^[a-zA-Z ]+$/;
      if (!enreg.test(privateParams.data.en_name)) {
        return params.success(_util.getCode(1020003))
      }
      if (privateParams.data.en_name.length > 32) {
        return params.success(_util.getCode(1020003))
      }
      if (_util.validEmpty(privateParams.data.en_name)) {
        return params.success(_util.getCode(1020003))
      }
    }
    // 生日验证
    if (privateParams.data.birthday !== undefined) {
      // var regBir = /^\d{4}-\d{2}-\d{2}$/;
      // var regBir = /^\d{4}-([0][123456789]|[1][012])-([012][123456789]|[3][01])$/;
      var regBir = /^(19|20)\d{2}\-((0?[1-9])|(1[0-2]))\-((0?[1-9])|([1-2]\d)|3[01])$/
      if (!regBir.test(privateParams.data.birthday)) {
        return params.success(_util.getCode(1020004))
      }
    }
    // 入学年级验证
    if (privateParams.data.school_year !== undefined) {
      var regBir = /^\d{4}$/;
      if (!regBir.test(privateParams.data.school_year)) {
        return params.success(_util.getCode(1020005))
      }
    }
    // 地区校验
    if (privateParams.data.province > 0) {
      if (privateParams.data.city <= 0) {
        return params.success(_util.getCode(1040001))
      }
    }
    this.asyncCheckLogin().then(function (res) {
      var setSpecialParams = {
        isCheckLogin: true,
        name: 'modifyUserInfo'
      }
      _util.axiosPost(new_host + '/web/user/modify', privateParams, setSpecialParams)
    }).catch(function (fail) {
      // 未登录，接口返回什么就是什么，原封不动返回给业务方
      if (fail.errcode) {
        params.success ? params.success(fail) : function (fail) { }
      } else {
        params.fail ? params.fail(fail) : function (fail) { }
      }
      params.complete ? params.complete(fail) : function (fail) { }
    })
  },
  /*
  * @discribe 上传用户头像
  * @method uploadPhoto
  * @param {params} 参数
  * @return {Boolean} 返回一个Promise对象
  * */
  uploadPhoto: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    // 判断是v1还是v2
    var new_host = cg_host_v1,
      _t = this
    // 已登录
    if (params.data.version) {
      new_host = cg_host_v2 + '/' + params.data.version
      delete params.data.version
    }
    // tal_id为空
    if (!_util.validNotEmpty(params.data.tal_id)) {
      params.success(_util.getCode(1040006));
      return
    }
    var allowArr = ['png', 'jpg', 'jpeg', 'gif'];
    var type = params.data.avatar.type
    var imgType = type.split('/')[1]
    if (allowArr.indexOf(imgType.toLocaleLowerCase()) == -1) {
      return params.success(_util.getCode(1020006))
    }
    var formData = new FormData();
    for (var i in params.data) {
      formData.append(i, params.data[i])
    }
    params.data = formData
    _t.asyncCheckLogin().then(function (res) {
      var setSpecialParams = {
        isCheckLogin: true,
        type: 'formdata',
        headersType: reqMultipart,
        name: 'uploadPhoto'
      }
      _util.axiosPost(new_host + '/web/user/avatar', params, setSpecialParams)
    }).catch(function (fail) {
      // 未登录，接口返回什么就是什么，原封不动返回给业务方
      if (fail.errcode) {
        params.success ? params.success(fail) : function (fail) { }
      } else {
        params.fail ? params.fail(fail) : function (fail) { }
      }
      params.complete ? params.complete(fail) : function (fail) { }
    })
  },
  /*
  * @discribe 新增收货地址
  * @method createAddress
  * @param {params} 参数
  * @return {Boolean} 返回一个Promise对象
  * */
  createAddress: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params);
    privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
    var nameLen = privateParams.data.name ? privateParams.data.name.length : 0;
    // 验证收货人姓名为空
    if (_util.validEmpty(privateParams.data.name)) {
      return params.success(_util.getCode(1030005))
    }
    // 验证收货人姓名合法性
    if (nameLen < 1 || nameLen > 32 || (!/^[a-z0-9A-Z&\-,（）(). \u4e00-\u9fa5]+$/.test(privateParams.data.name))) {
      return params.success(_util.getCode(1030001))
    }
    /*不支持香港只验证大陆*/
    // 验证手机号为空
    if (_util.validEmpty(privateParams.data.phone)) {
      return params.success(_util.getCode(1030006))
    }
    // // 验证手机号的合法性
    // if (!_util.validPhone(privateParams.data.phone, '86')) {
    //   return params.success(_util.getCode(1030007))
    // }
    // 验证省份信息为空
    if (!privateParams.data.province) {
      return params.success(_util.getCode(1040003))
    }
    // 验证省份信息合法性
    if (privateParams.data.province <= 0) {
      return params.success(_util.getCode(1040000))
    }
    // 验证城市信息为空
    if (!privateParams.data.city) {
      return params.success(_util.getCode(1040004))
    }
    // 验证城市信息合法性
    if (privateParams.data.city <= 0) {
      return params.success(_util.getCode(1040001))
    }
    // 验证区县信息为空
    if (!privateParams.data.county) {
      return params.success(_util.getCode(1040005))
    }
    // 验证区县信息合法性
    if (privateParams.data.county <= 0) {
      return params.success(_util.getCode(1040002))
    }
    // 验证收货地址详细信息为空
    if (_util.validEmpty(privateParams.data.detail)) {
      return params.success(_util.getCode(1030008))
    }
    // 验证收货地址详细信息合法性
    if (privateParams.data.detail.length > 100) {
      return params.success(_util.getCode(1030003))
    }
    // 验证备注信息长度合法性
    if (privateParams.data.remark) {
      if (_util.trim(privateParams.data.remark).length > 100) {
        return params.success(_util.getCode(1030004))
      }
    }
    this.asyncCheckLogin().then(function (res) {
      var setSpecialParams = {
        isCheckLogin: true,
        name: 'createAddress'
      }
      _util.axiosPost(cg_host_v1 + '/web/address/create', privateParams, setSpecialParams)
    }).catch(function (fail) {
      // 未登录，接口返回什么就是什么，原封不动返回给业务方
      if (fail.errcode) {
        params.success ? params.success(fail) : function (fail) { }
      } else {
        params.fail ? params.fail(fail) : function (fail) { }
      }
      params.complete ? params.complete(fail) : function (fail) { }
    })
  },
  /*
  * @discribe 获取地址列表
  * @method listAddress
  * @param {params} 参数
  * @return {Boolean} 返回一个Promise对象
  * */
  listAddress: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params);
    this.asyncCheckLogin().then(function (res) {
      var setSpecialParams = {
        isCheckLogin: true,
        name: 'listAddress'
      }
      _util.axiosGet(cg_host_v1 + '/web/address/list', privateParams, setSpecialParams)
    }).catch(function (fail) {
      // 未登录，接口返回什么就是什么，原封不动返回给业务方
      if (fail.errcode) {
        params.success ? params.success(fail) : function (fail) { }
      } else {
        params.fail ? params.fail(fail) : function (fail) { }
      }
      params.complete ? params.complete(fail) : function (fail) { }
    })
  },
  /*
  * @discribe 获取地址信息
  * @method listAddress
  * @param {params} 参数
  * @return {Boolean} 返回一个Promise对象
  * */
  infoAddress: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params);
    // 地址id非空校验
    if (!privateParams.data.addr_id) {
      return params.success(_util.getCode(1030000))
    }
    this.asyncCheckLogin().then(function (res) {
      var setSpecialParams = {
        isCheckLogin: true,
        name: 'infoAddress'
      }
      _util.axiosPost(cg_host_v1 + '/web/address/info', privateParams, setSpecialParams)
    }).catch(function (fail) {
      // 未登录，接口返回什么就是什么，原封不动返回给业务方
      if (fail.errcode) {
        params.success ? params.success(fail) : function (fail) { }
      } else {
        params.fail ? params.fail(fail) : function (fail) { }
      }
      params.complete ? params.complete(fail) : function (fail) { }
    })
  },
  /*
  * @discribe 修改地址
  * @method modifyAddress
  * @param {params} 参数
  * @return {Boolean} 返回一个Promise对象
  * */
  modifyAddress: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params);
    privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
    var nameLen = privateParams.data.name ? privateParams.data.name.length : 0;
    // 验证收货人姓名为空
    if (_util.validEmpty(privateParams.data.name)) {
      return params.success(_util.getCode(1030005))
    }
    // 验证收货人姓名合法性
    if (nameLen < 1 || nameLen > 32 || (!/^[a-z0-9A-Z&\-,（）(). \u4e00-\u9fa5]+$/.test(privateParams.data.name))) {
      return params.success(_util.getCode(1030001))
    }
    /*不支持香港只验证大陆*/
    // 验证手机号为空
    if (_util.validEmpty(privateParams.data.phone)) {
      return params.success(_util.getCode(1030006))
    }
    // 验证手机号的合法性
    // if (!_util.validPhone(privateParams.data.phone, '86')) {
    //   return params.success(_util.getCode(1030007))
    // }
    // 验证省份信息为空
    if (!privateParams.data.province) {
      return params.success(_util.getCode(1040003))
    }
    // 验证省份信息合法性
    if (privateParams.data.province <= 0) {
      return params.success(_util.getCode(1040000))
    }
    // 验证城市信息为空
    if (!privateParams.data.city) {
      return params.success(_util.getCode(1040004))
    }
    // 验证城市信息合法性
    if (privateParams.data.city <= 0) {
      return params.success(_util.getCode(1040001))
    }
    // 验证区县信息为空
    if (!privateParams.data.county) {
      return params.success(_util.getCode(1040005))
    }
    // 验证区县信息合法性
    if (privateParams.data.county <= 0) {
      return params.success(_util.getCode(1040002))
    }
    // 验证收货地址详细信息为空
    if (_util.validEmpty(privateParams.data.detail)) {
      return params.success(_util.getCode(1030008))
    }
    // 验证收货地址详细信息合法性
    if (privateParams.data.detail.length > 100) {
      return params.success(_util.getCode(1030003))
    }
    // 验证备注信息长度合法性
    if (privateParams.data.remark) {
      if (_util.trim(privateParams.data.remark).length > 100) {
        return params.success(_util.getCode(1030004))
      }
    }
    this.asyncCheckLogin().then(function (res) {
      var setSpecialParams = {
        isCheckLogin: true,
        name: 'modifyAddress'
      }
      _util.axiosPost(cg_host_v1 + '/web/address/modify', privateParams, setSpecialParams)
    }).catch(function (fail) {
      // 未登录，接口返回什么就是什么，原封不动返回给业务方
      if (fail.errcode) {
        params.success ? params.success(fail) : function (fail) { }
      } else {
        params.fail ? params.fail(fail) : function (fail) { }
      }
      params.complete ? params.complete(fail) : function (fail) { }
    })
  },
  /*
  * @discribe 设置默认地址
  * @method defaultAddress
  * @param {params} 参数
  * @return {Boolean} 返回一个Promise对象
  * */
  defaultAddress: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    params.data.is_default = '1'
    var privateParams = getParams(params);
    // 地址id非空校验
    if (!privateParams.data.addr_id) {
      return params.success(_util.getCode(1030000))
    }
    this.asyncCheckLogin().then(function (res) {
      var setSpecialParams = {
        isCheckLogin: true,
        name: 'defaultAddress'
      }
      _util.axiosPost(cg_host_v1 + '/web/address/modify', privateParams, setSpecialParams)
    }).catch(function (fail) {
      // 未登录，接口返回什么就是什么，原封不动返回给业务方
      if (fail.errcode) {
        params.success ? params.success(fail) : function (fail) { }
      } else {
        params.fail ? params.fail(fail) : function (fail) { }
      }
      params.complete ? params.complete(fail) : function (fail) { }
    })
  },
  /*
  * @discribe 取消默认地址
  * @method defaultAddress
  * @param {params} 参数
  * @return {Boolean} 返回一个Promise对象
  * */
  cancelAddress: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    params.data.is_default = '2'
    var privateParams = getParams(params);
    // 地址id非空校验
    if (!privateParams.data.addr_id) {
      return params.success(_util.getCode(1030000))
    }
    this.asyncCheckLogin().then(function (res) {
      var setSpecialParams = {
        isCheckLogin: true,
        name: 'cancelAddress'
      }
      _util.axiosPost(cg_host_v1 + '/web/address/modify', privateParams, setSpecialParams)
    }).catch(function (fail) {
      // 未登录，接口返回什么就是什么，原封不动返回给业务方
      if (fail.errcode) {
        params.success ? params.success(fail) : function (fail) { }
      } else {
        params.fail ? params.fail(fail) : function (fail) { }
      }
      params.complete ? params.complete(fail) : function (fail) { }
    })
  },
  /*
  * @discribe 删除地址
  * @method delAddress
  * @param {params} 参数
  * @return {Boolean} 返回一个Promise对象
  * */
  delAddress: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params);
    // 地址id非空校验
    if (!privateParams.data.addr_id) {
      return params.success(_util.getCode(1030000))
    }
    this.asyncCheckLogin().then(function (res) {
      var setSpecialParams = {
        isCheckLogin: true,
        name: 'delAddress'
      }
      _util.axiosPost(cg_host_v1 + '/web/address/del', privateParams, setSpecialParams)
    }).catch(function (fail) {
      // 未登录，接口返回什么就是什么，原封不动返回给业务方
      if (fail.errcode) {
        params.success ? params.success(fail) : function (fail) { }
      } else {
        params.fail ? params.fail(fail) : function (fail) { }
      }
      params.complete ? params.complete(fail) : function (fail) { }
    })
  },
  /********* 地区信息省市区相关 ********/
  /*
  * @discribe 获取省信息
  * @method getProvinces
  * @param {params} 参数
  * @return {Promise} 返回一个Promise对象
  * */
  getProvinces: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params)
    _util.axiosGet(passport_host_v1 + '/web/area/province/list', privateParams)
  },
  /*
  * @discribe 根据省id获取市信息
  * @method getCity
  * @param {params} 参数
  * @return {Promise} 返回一个Promise对象
  * */
  getCitys: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params)
    if (!_util.validNotEmpty(privateParams.data.province_id)) {
      return params.success(_util.getCode(1040003))
    }
    _util.axiosGet(passport_host_v1 + '/web/area/city/list', privateParams)
  },
  /*
  * @discribe 根据市id获取区县信息
  * @method getCounty
  * @param {params} 参数
  * @return {Promise} 返回一个Promise对象
  * */
  getCounty: function (params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params)
    if (!_util.validNotEmpty(privateParams.data.citie_id)) {
      return params.success(_util.getCode(1040004))
    }
    _util.axiosGet(passport_host_v1 + '/web/area/county/list', privateParams)
  },
  /*
  * @discribe 心跳接口
  * @param {params} 参数
  * */
  checkHeartbeat: function (params) {
    if (!_util.validResHeader()) return (params.success ? params.success(_util.getCode(1000000)) : '')
    var privateParams = getParams(params)
    // resetSessionStorage
    // 判断本地缓存sessionStorage是否存在tal-passport-jssdk-tal-token字段，存在该接口设置Tal-Token字段header头，否则不设置该字段
    var getSessionStorageTalToken = _util.resetSessionStorage.getItem('tal-passport-jssdk-tal-token') || ''
    // 设置header头字段数据
    var setRequestHeaderArr = []
    if (getSessionStorageTalToken) {
      setRequestHeaderArr.push({
        fieldName: 'Tal-Token',
        fieldValue: getSessionStorageTalToken || ''
      })
    }
    var setSpecialParams = {
      addHeaders: setRequestHeaderArr,
      name: 'checkHeartbeat'
    }
    _util.axiosPost(passport_host_v1 + '/web/login/status/check', privateParams, setSpecialParams)
  },

  /**
   * @name: startPollingQRCodeStatus
   * @description: 轮询二维码的状态
   * @param {qrcodeId} 二维码code_id
   * @param {interval} 轮询间隔时间
   * @param {onResult} 每次轮询成功获取到二维码状态数据的回调
   * @param {onScanned} 用户扫码时回调
   * @param {onExpired} 二维码失效，过期回调
   * @param {successCallback} 用户同意授权时回调
   * @param {onCancel} 用户取消授权时回调
   * @param {onError} 获取二维码状态接口失败（errcode !== 0）时回调
   * @return:
   */
  qrCodeStartPollingStatus(options = {}) {
    let { qrcodeId,
      onResult,
      onScanned,
      onExpired,
      successCallback,
      onCancel,
      onError,
      setQrcodeStatus } = options;
    let calledOnScanned = false,
      interval = 1000,
      _t = this;
    function setTimeouthandler() {
      intervalNum = setTimeout(() => {
        _util.axiosGet(passport_host_v1 + '/web/login/qrcode/check', {
          data: {
            code_id: qrcodeId || ''
          },
          success: function (res) {
            if (res.errcode === 0) {
              const { data } = res;
              //每次轮询成功获取查询二维码状态接口的数据
              if (onResult) {
                onResult(res)
              }
              //用户扫码成功---同意授权-成功登陆
              if (data.code_status === 3 && setQrcodeStatus != data.code_status) {
                // 扫码成功之后不再执行定时器
                clearTimeout(intervalNum);
                const successDataCode = {
                  "data": {
                    "code": data.code
                  }
                };
                const successData = Object.assign(res, successDataCode);
                if (successCallback && typeof successCallback === 'function') {
                  successCallback(successData)
                }
              }
              //用户已扫码---暂时没有任何操作（同意与否）
              if (data.code_status === 2 && setQrcodeStatus != data.code_status) {
                if (onScanned) {
                  onScanned()
                }
              }
              //二维码已失效或者已过期
              if (data.code_status === 4 && setQrcodeStatus != data.code_status) {
                // 二维码已失效或者已过期之后不再执行定时器
                clearTimeout(intervalNum)
                //提示用户重新生成二维码
                if (onExpired) {
                  onExpired()
                }
              }
              //用户扫码成功---但取消授权登陆
              if (data.code_status === 5 && setQrcodeStatus != data.code_status) {
                // 用户扫码成功---但取消授权登陆之后不再执行定时器
                clearTimeout(intervalNum)
                //提示用户重新生成二维码
                if (onCancel) {
                  onCancel()
                }
              }

              // data.code_status!=3、4、5时 重启下一个请求轮询
              if (data.code_status != 3 && data.code_status != 4 && data.code_status != 5) {
                setTimeouthandler()
              }
              // 设置二维码状态setQrcodeStatus
              setQrcodeStatus = data.code_status || ''
            } else {
              // 重启下一个请求轮询
              // setTimeouthandler()
              //获取二维码状态查询失败回调 (errcode !== 0) --- 登陆失败UI页面
              if (onError) {
                onError(res)
              }
            }
          },
          fail: function (res) {
            // 请求失败，重启下一个请求轮询
            setTimeouthandler()
          }
        })
      }, interval)
    }
    setTimeouthandler()
    // return intervalNum
  },

  /**
   * @name: cancelQrcode
   * @description: 切换到非二维码登录方式的特殊处理
   * @param {type} null
   * @return: null
   */
  cancelQrcode() {
    // 清除dom轮询定时器
    if (intervalRenderDomNum) {
      clearInterval(intervalRenderDomNum)
    }
    // 清除检测二维码状态定时器
    if (intervalNum) {
      clearTimeout(intervalNum);
    }
    const createScanExpired = (onClickTh) => {
      //创建蒙版
      let shadowId = 'tal_retry';
      if (document.getElementById(shadowId)) {
        _util.removeElement(document.getElementById(shadowId));
      }
      const shadow_box = document.createElement('div');
      shadow_box.id = shadowId;
      //状态语
      const tip_s = document.createElement('p');
      tip_s.id = 'tal_heading-subtitle';
      tip_s.innerHTML = "二维码已失效";
      //提示警告语
      const tip_w = document.createElement('a');
      tip_w.id = 'tal_heading-subtitle-expired';
      tip_w.onclick = onClickTh;
      tip_w.innerHTML = '点击刷新';

      const tip_box = document.createElement('div');
      tip_box.id = 'tal_tip-inner'

      tip_box.appendChild(tip_s);
      tip_box.appendChild(tip_w);
      shadow_box.appendChild(tip_box);

      return shadow_box;
    }

    if (qrCodeBoxNode) {
      // 如果采取v-if显示隐藏二维码渲染dom，此时已经不存在渲染dom中的任何结构
      setTimeout(function () {
        const wrapper = "tal_qrcode-wrapper"
        const wrapperEle = document.getElementById(wrapper)
        if (wrapperEle) {
          wrapperEle.appendChild(createScanExpired(() => { startShow(3) }))
        }
      })
    }
  },

  /**
   * @name: loginQrcode
   * @description: 微信扫码登录web端流程
   * @param {renderToEle} 需要渲染的DOM ID
   * @param {onScanned} 用户扫码时回调
   * @param {onExpired} 二维码失效，过期回调
   * @param {successCallback} 用户同意授权时回调
   * @param {onCancel} 用户取消授权时回调
   * @param {onError} 获取二维码状态接口失败（errcode !== 0）时回调
   * @return:
   */
  loginQrcode(options = {}) {
    let { renderToEle,
      onScanned,
      onExpired,
      successCallback,
      onCancel,
      onError,
      onQRCodeShow,
      onQRCodeLoad,
      onQRCodeLoadFaild,
      netWorkErrTips = "网络出错，请重试"
    } = options;
    var _t = this,
      renderDomNum = 1;
    // 初始化之前如果定时器存在先清除
    if (intervalRenderDomNum) {
      clearInterval(intervalRenderDomNum)
    }
    // 异步，目的为了v-if显示renderToEle时能够获取到dom
    intervalRenderDomNum = setTimeout(function () {
      // 渲染dom最多不超过2s即20次轮询，超过停止轮询，清除定时器
      if (renderDomNum > 20) {
        clearInterval(intervalRenderDomNum)
      }
      renderDomNum += 1
      //挂载渲染的元素id
      const mountNode = renderToEle;
      qrCodeBoxNode = document.querySelector(mountNode);
      let qrcodeNode = document.querySelector(mountNode);
      if (qrcodeNode) {
        // 渲染dom存在之后清除定时器intervalRenderDomNum
        clearInterval(intervalRenderDomNum)
        let qrcodeWrapper;

        //点击刷新的loading元素
        const loading = () => {
          qrcodeNode.innerHTML = '<div id="tal_qrcode-wrapper"><div id="tal_spinner" class="tal_spinner"><div class="tal_spinner-container"><span class="spinner-snake"></span><span class="spinner-text">加载中</span></div></div></div>'
        };

        const unloading = () => {
          const child = document.getElementById('tal_qrcode-wrapper');
          qrcodeNode.removeChild(child);
        };

        //创建扫码成功状态元素
        const createScanSuccess = () => {
          //创建蒙版
          let shadowId = 'tal_retry';
          if (document.getElementById(shadowId)) {
            _util.removeElement(document.getElementById(shadowId));
          }
          const shadow_box = document.createElement('div');
          shadow_box.id = shadowId;
          //状态语
          const tip_s = document.createElement('span');
          tip_s.id = 'tal_heading-subtitle';
          tip_s.innerHTML = '扫描成功';
          //提示警告语
          const tip_w = document.createElement('p');
          tip_w.id = 'tal_heading-subtitle-warn';
          tip_w.innerHTML = '请在手机上根据提示确认登录';
          //提示icon
          const warn_icon_inner = document.createElement('div');
          const warn_icon = document.createElement('div');
          warn_icon_inner.id = 'tal_heading-icon-fail-inner'
          warn_icon.id = 'tal_heading-icon-success'
          warn_icon_inner.appendChild(warn_icon)

          const tip_box = document.createElement('div');
          tip_box.id = 'tal_tip-inner'

          tip_box.appendChild(warn_icon_inner);
          tip_box.appendChild(tip_s);
          tip_box.appendChild(tip_w);
          shadow_box.appendChild(tip_box);

          return shadow_box;
        }


        //创建扫码登陆失败状态元素
        const createScanFail = (onClickTh) => {
          //创建蒙版
          let shadowId = 'tal_retry';
          if (document.getElementById(shadowId)) {
            _util.removeElement(document.getElementById(shadowId));
          }
          const shadow_box = document.createElement('div');
          shadow_box.id = shadowId;
          //状态语
          const tip_s = document.createElement('span');
          tip_s.id = 'tal_heading-subtitle';
          tip_s.innerHTML = "登录失败";
          //提示警告语
          const tip_w = document.createElement('p');
          tip_w.id = 'tal_heading-subtitle-warn';

          const tip_w_b = document.createElement('span');
          tip_w_b.innerHTML = '重新扫描二维码，点击'
          const tip_w_r = document.createElement('a');
          tip_w_r.id = 'tal_heading-subtitle-refresh';
          tip_w_r.onclick = onClickTh;
          tip_w_r.innerHTML = '刷新';
          tip_w.appendChild(tip_w_b)
          tip_w.appendChild(tip_w_r)
          //提示icon
          const warn_icon_inner = document.createElement('div');
          const warn_icon = document.createElement('div');
          warn_icon_inner.id = 'tal_heading-icon-fail-inner'
          warn_icon.id = 'tal_heading-icon-fail'
          warn_icon_inner.appendChild(warn_icon)

          const tip_box = document.createElement('div');
          tip_box.id = 'tal_tip-inner'

          tip_box.appendChild(warn_icon_inner);
          tip_box.appendChild(tip_s);
          tip_box.appendChild(tip_w);
          shadow_box.appendChild(tip_box);

          return shadow_box;
        }

        //创建二维码失效-过期状态元素
        const createScanExpired = (onClickTh) => {
          //创建蒙版
          let shadowId = 'tal_retry';
          if (document.getElementById(shadowId)) {
            _util.removeElement(document.getElementById(shadowId));
          }
          const shadow_box = document.createElement('div');
          shadow_box.id = shadowId;
          //状态语
          const tip_s = document.createElement('p');
          tip_s.id = 'tal_heading-subtitle';
          tip_s.innerHTML = "二维码已失效";
          //提示警告语
          const tip_w = document.createElement('a');
          tip_w.id = 'tal_heading-subtitle-expired';
          tip_w.onclick = onClickTh;
          tip_w.innerHTML = '点击刷新';

          const tip_box = document.createElement('div');
          tip_box.id = 'tal_tip-inner'

          tip_box.appendChild(tip_s);
          tip_box.appendChild(tip_w);
          shadow_box.appendChild(tip_box);

          return shadow_box;
        }

        //创建二维码图片
        const createQRCode = (src) => {
          const qrcodeImage = document.createElement('img');
          qrcodeImage.id = 'tal_qrcode';
          qrcodeImage.src = src;
          return qrcodeImage;
        };

        //获取二维码接口请求失败
        const getQRCodeFail = (qrcodeElm) => {
          qrcodeWrapper = document.createElement('div');
          qrcodeWrapper.id = 'tal_qrcode-wrapper';

          // 这里替换一个二维码假数据
          const qrcodeImage = createQRCode('https://gblobscdn.gitbook.com/assets%2F-LdsKjoPVRBStTP-5zXe%2F-LxAQpSlzRkSs4UdaL4x%2F-LxARd7Blg5lxKDAJlH2%2Fimage.png?alt=media&token=216aaa82-4bd2-4b88-aa4e-bf9601ca9582');

          qrcodeImage.onload = () => {
            unloading();
          };

          const shadow = createScanFail(() => { startShow(2) });

          qrcodeWrapper.appendChild(qrcodeImage);
          qrcodeWrapper.appendChild(shadow);
          qrcodeElm.appendChild(qrcodeWrapper);
        }
        startShow = (generate_type) => {
          if (intervalNum) {
            clearTimeout(intervalNum);
          };
          loading();
          // 请求二维码
          var setParams = {
            image_type: 2,
            generate_type: generate_type
          },
            getRouterUrl = _util.parseStr(window.location.href.split('?')[1]),
            dev_flag = getRouterUrl.tal_passport_flag_20200420 || ''
          if (dev_flag) {
            setParams.dev_flag = dev_flag
          }
          _util.axiosGet(passport_host_v1 + '/web/login/qrcode/get', {
            data: setParams,
            success: function (res) {
              if (res.errcode !== 0) {
                //获取二维码接口信息失败回调
                getQRCodeFail(qrcodeNode);
                if (onQRCodeLoadFaild) {
                  onQRCodeLoadFaild(res);
                }
              } else {
                const { code_id, content } = res.data
                if (onQRCodeLoad) {
                  const qrcode = {
                    code_id: code_id,
                    content: content
                  }
                  // 二维码首次成功加载时回调  参数是二维码信息
                  onQRCodeLoad(qrcode);
                }
                if (qrcodeNode) {
                  qrcodeWrapper = document.createElement('div');
                  qrcodeWrapper.id = 'tal_qrcode-wrapper';

                  const qrcodeImage = createQRCode(content);
                  qrcodeImage.onload = () => {
                    unloading();
                    if (onQRCodeShow) {
                      onQRCodeShow();
                    };
                    // 用户同意授权-成功登录
                    let decoOnSuccess = function (data) {
                      if (successCallback && typeof successCallback === 'function') {
                        successCallback(data)
                      }
                    };
                    // 已扫码
                    let decoOnScanned = function (data) {
                      const shadow = createScanSuccess();
                      qrcodeWrapper.appendChild(shadow);
                      if (onScanned) {
                        onScanned(data)
                      }
                    }
                    // 已失效已过期
                    let decoOnExpired = function () {
                      const shadow = createScanExpired(() => { startShow(3) });
                      qrcodeWrapper.appendChild(shadow);
                      if (onExpired) {
                        onExpired()
                      }
                    }
                    // 用户取消授权
                    let decoOnCancel = function (data) {
                      const shadow = createScanExpired(() => { startShow(3) });
                      qrcodeWrapper.appendChild(shadow);
                      if (onCancel) {
                        onCancel(data)
                      }
                    }
                    // 获取二维码信息接口code！= 0失败
                    let decoOnError = function (data) {
                      const shadow = createScanFail(() => { startShow(2) });
                      qrcodeWrapper.appendChild(shadow);
                      if (onError) {
                        onError(data)
                      }
                    }
                    // 开始轮询二维码status
                    _t.qrCodeStartPollingStatus({
                      qrcodeId: code_id,
                      onScanned: decoOnScanned,
                      onExpired: decoOnExpired,
                      successCallback: decoOnSuccess,
                      onCancel: decoOnCancel,
                      onError: decoOnError,
                      setQrcodeStatus: ''
                    });
                  };
                  qrcodeWrapper.appendChild(qrcodeImage);
                  qrcodeNode.appendChild(qrcodeWrapper);
                }
              }
            },
            fail: function (err) {
              //网络出错
              getQRCodeFail(qrcodeNode);
              if (onQRCodeLoadFaild) {
                onQRCodeLoadFaild(err);
              }
            }
          })
        }
        startShow(1);
      }
    }, 100)

  },
  /**
   * @name: authorizationInfo
   * @description: code值换取页面渲染绑定信息
   * @param {type} code校验信息
   * @return
  */
  authorizationInfo(params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params)
    _util.axiosGet(passport_host_v1 + '/web/authorization', privateParams)
  },

  /**
   * @name: authorizationConfirm
   * @description: 确认授权
   * @param {type} null
   * @return
  */
  authorizationConfirm(params, captchaData) {
    console.log('authorizationConfirm 被调用, captchaData:', captchaData)

    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))

    var privateParams = getParams(params)
    var _t = this;
    var set_host = passport_host_v1;
    var is_token = false; // authorizationConfirm 不需要登录态
    // 设置特殊参数
    var setSpecialParams = {
      isCheckLogin: false,
      name: 'authorizationConfirm'
    }

    var sendRequest = function (captchaVerifyParam) {
      console.log('authorizationConfirm sendRequest 被调用, captchaVerifyParam:', captchaVerifyParam)
      // 只有当 captchaVerifyParam 是字符串类型时，才认为是阿里无感验证码数据
      // 图形验证码数据是对象类型 {requestType: 1, captchaVal: '...'}
      if (captchaVerifyParam && typeof captchaVerifyParam === 'string') {
        try {
          let captchaVerifyParamObj = JSON.parse(captchaVerifyParam);
          // 确认包含 sceneId 字段，进一步确保是阿里验证码数据
          if (captchaVerifyParamObj && captchaVerifyParamObj.sceneId) {
            privateParams.data.invisible_sig = captchaVerifyParam;
            privateParams.data.invisible_sig_scene = captchaVerifyParamObj.sceneId;
            console.log('authorizationConfirm - 设置阿里无感验证码参数')
          }
        } catch (e) {
          console.warn('authorizationConfirm - 解析验证码参数失败:', e)
        }
      }
      console.log('authorizationConfirm 准备发送请求, 请求参数:', privateParams.data)

      _util.axiosPost(set_host + '/web/authorization/confirm', privateParams)
    }

    // 如果是第二次校验（已经通过滑块验证），直接调用接口
    console.log('authorizationConfirm 判断是否已有验证数据: is_second_verify=', privateParams.data.is_second_verify, 'captchaData=', captchaData)
    if (captchaData) {
      console.log('authorizationConfirm - 已有验证数据，直接发送请求')
      sendRequest(captchaData)
      return
    }

    console.log('authorizationConfirm 未检测到验证数据，准备触发滑块')
    // 判断是否初始化滑块
    if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
      console.log('authorizationConfirm - 开始等待阿里验证码初始化')
      window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function (res) {
        console.log('authorizationConfirm - 阿里验证码初始化完成', res)

        // 阿里风控2.0能力调用
        if (window.initAliyunCaptcha) {
          console.log('authorizationConfirm - 触发阿里验证码')
          // 保存上下文，用于滑块成功后回调
          sdkCallbackContext = {
            method: 'authorizationConfirm',
            params: params,
            captchaData: null
          };
          // 触发阿里滑块按钮点击
          document.getElementById('tal-udc-captcha-button-for-aliyun').click()
          console.log('authorizationConfirm - 触发阿里验证码成功=====并点击了按钮')
        } else {
          // 没有 initAliyunCaptcha 方法，直接发送请求
          console.log('authorizationConfirm - 没有阿里验证码，直接发送请求')
          sendRequest()
        }
      }).catch(function(err) {
        // Promise 异常，直接发送请求
        console.error('阿里验证码初始化异常，直接发送请求', err)
        sendRequest()
      })
    } else {
      // 没有初始化滑块，直接发送请求
      console.log('authorizationConfirm 没有初始化滑块配置，直接发送请求')
      sendRequest()
    }
  },
  /**
   * @name: getAuthCgList
   * @description: 业务平台获取授权登录的cg列表
   * @param {type} null
   * @return
  */
  getAuthCgList(params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    // console.log(8888000)
    var privateParams = getParams(params)
    _util.axiosPost(passport_host_v1 + '/web/login/cg/list', privateParams)
  },
  /**
   * @name: getCaptcha
   * @description: 获取验证码/点击图片刷新验证码/点击看不清刷新
   * @param {type} type=1为首次获取验证码，为2为刷新验证码
   * @return
  */
  getCaptcha(type, params) {
    var captchaUrl = '',
      _this = this
    var language = configNVCInitParams.language || 'cn'
    // 动态创建css
    if (!_util.isIncludeFile('captcha.css')) {
      var link = document.createElement('link')
      link.type = 'text/css'
      link.href = ucresHost + '/libs/jssdk/lib/captcha.css'
      link.rel = 'stylesheet'
      document.getElementsByTagName('head').item(0).appendChild(link)
    }
    var setParams = getParams(params)
    setParams.captchaParams.data.scene = setParams.sceneType
    setParams.captchaParams.data.uniq_captcha = setParams.uniq_captcha
    var set_captchaParams = {
      data: setParams.captchaParams.data,
      success: (res) => {
        console.log(res)
        if (res.errcode == 0) {
          captchaUrl = res.data.captcha
          // 获取图形码成功后调用页面结构
          if (type == 1) {
            _this.showCaptcha(captchaUrl, params)
          } else {
            // 刷新验证码，更新图片
            var captchaPic = document.getElementById('tal-passport-captcha-pic')
            if (captchaPic) {
              captchaPic.src = captchaUrl
            }
          }
        } else if (res.errcode == 14106) {
          // 不显示图形验证，直接接口通过
          // 设置场景数据
          var captchaData = {
            requestType: 2
          }
          if (_this[params.captchaCallback]) {
            _this[params.captchaCallback](params.captchaParams, captchaData)
          }
        } else {
          _this.showPassportToast(errMsgLang[language][res.errcode] || res.errmsg)
        }
      },
      fail: (err) => {
        console.log(err)
      }
    }
    // 判断是否需要登录态
    if (setParams.checkToken) {
      _this.asyncCheckLogin().then(function (res) {
        _util.axiosPost(setParams.host + '/web/captcha/get', set_captchaParams, setParams.specialParams)
      }).catch(function (fail) {
        // 未登录
        _this.showPassportToast(errMsgLang[language][fail.errcode] || fail.errmsg)
      })
    } else {
      _util.axiosPost(setParams.host + '/web/captcha/get', set_captchaParams)
    }
  },
  /**
   * @name: showCaptcha
   * @description: 生成图形验证码弹窗
   * @param {type} null
   * @param {Object} captchaParams 请求图形验证码参数对象
   * @return
  */
  showCaptcha(captchaUrl, captchaParams) {
    console.log(configNVCInitParams, 'configNVCInitParams======')
    var language = configNVCInitParams.language || 'cn'
    console.log(language, 'language======')
    var languageMap = {
      'cn': {
        'title': '安全验证',
        'placeholder': '请输入验证码',
        'refresh_text': '看不清，',
        'refresh_btn': '刷新',
        'submit': '确定'
      },
      'en': {
        'title': 'Security Verification',
        'placeholder': 'Verification Code',
        'refresh_text': 'Need a clearer image?',
        'refresh_btn': 'Refresh',
        'submit': 'Submit'
      }
    }
    var captchaUrl = captchaUrl,
      _this = this

    // 检查是否已存在验证码弹窗，如果存在则先移除
    var existingCaptcha = document.getElementById('tal-passport-captcha')
    if (existingCaptcha) {
      console.log('检测到已存在的验证码弹窗，先移除')
      _util.removeElement(existingCaptcha)
    }

    // 图形验证码页面结构
    var Captcha = `<div class="tal-passport-captcha" id="tal-passport-captcha">
                            <div class="tal-passport-captcha_content">
                                <div class="tal-passport-captcha_top">
                                    <span class="tal-passport-captcha_title">${languageMap[language].title}</span>
                                    <img id="tal-passport-captcha_close" class="tal-passport-captcha_close" src="`+ ucresHost + `/libs/jssdk/lib/img/location_nav_close_btn.png" />
                                </div>
                                <div class="tal-passport-captcha_middle">
                                    <div class='tal-passport-captcha_shape' id='tal-passport-captcha_shape'><img id="tal-passport-captcha-pic" src='`+ captchaUrl + `'/></div>
                                    <p  class='tal-passport-captcha_refresh' id='tal-passport-captcha_refresh'>${languageMap[language].refresh_text} <span>${languageMap[language].refresh_btn}</span></p>
                                </div>
                                <div class="tal-passport-captcha_bottom">
                                    <div class='tal-passport-captcha_fill'><input id="tal-passport-captcha-fill" placeholder="${languageMap[language].placeholder}" maxlength="4" type='text'/></div>
                                    <button disabled="true" id="tal-passport-captcha-btn" class='tal-passport-captcha_submit'><img id="tal-passport-btn-loading" class='tal_passport_captcha_button_loading' style="display: none;" src="`+ ucresHost + `/libs/jssdk/lib/img/tal_button_loading.png"/><span class="tal_passport_captcha_button_submit">${languageMap[language].submit}</span></button>
                                </div>
                            </div>
                            <div id="talPassportCaptchaMask" class="tal-passport-captcha_mask"></div>
                        </div>`;
    var captchaEle = document.createElement("div");
    captchaEle.innerHTML = Captcha;
    // 判断接入方是否配置将弹窗插入全局或者局部
    if (captchaContent == "") {
      // document.body.style.position = 'relative'
      document.body.appendChild(captchaEle)
    } else {
      document.getElementById(captchaContent).style.position = 'relative'
      document.getElementById(captchaContent).appendChild(captchaEle)
    }
    _util.addEvent(["input", "oninput"], document.getElementById('tal-passport-captcha-fill'), function (event) {
      _this.fillCaptcha(event)
    })
    _util.addEvent(["porpertychange", "onporpertychange"], document.getElementById('tal-passport-captcha-fill'), function (event) {
      _this.fillCaptcha(event)
    })
    document.getElementById('tal-passport-captcha-btn').onclick = function () {
      _this.submitCaptcha(captchaParams)
    }
    document.getElementById('tal-passport-captcha_shape').onclick = document.getElementById('tal-passport-captcha_refresh').onclick = function () {
      _this.getCaptcha(2, captchaParams)
    }
    document.getElementById('tal-passport-captcha_close').onclick = function () {
      _this.closeCaptcha(2, captchaParams)
    }
  },
  /**
    * @name: fillCaptcha
    * @description: 实时计算input输入内容
    * @param {type} null
    * @return
   */
  fillCaptcha(e, length) {
    var talPassportCaptchaFillValue = document.getElementById('tal-passport-captcha-fill').value,
      length = length || 4;
    if (talPassportCaptchaFillValue.length >= length) {
      document.getElementById('tal-passport-captcha-btn').removeAttribute('disabled')
    } else {
      var loadingBtn = document.getElementById('tal-passport-btn-loading')
      if (loadingBtn) {
        loadingBtn.style.display = 'none'
      }
      document.getElementById('tal-passport-captcha-btn').setAttribute('disabled', true)
    }
  },
  /**
    * @name: submitCaptcha
    * @description: 提交验证码
    * @param {type} null
    * @return
   */
  submitCaptcha(params) {
    // 判断是否在请求中
    if (captchaLoding) return false
    captchaLoding = true
    var talPassportCaptchaFillValue = document.getElementById('tal-passport-captcha-fill').value,
      _this = this;
    var loadingBtn = document.getElementById('tal-passport-btn-loading')
    if (loadingBtn) {
      loadingBtn.style.display = 'block'
    }
    // 设置场景数据
    var captchaData = {
      requestType: 1,
      captchaVal: talPassportCaptchaFillValue || ''
    }
    // 如果有 requestData，说明是通过 captchaSendFn 调用的图形验证码，应该回调 captchaSendFn
    // 这样可以复用 captchaSendFn 中设置 captcha 参数的逻辑
    if (params.requestData) {
      console.log('submitCaptcha - 检测到 requestData，回调 captchaSendFn')
      _this.captchaSendFn(params.captchaParams, params.requestData, captchaData)
    } else if (_this[params.captchaCallback]) {
      // 向后兼容：如果没有 requestData，直接回调业务方法（旧的逻辑）
      console.log('submitCaptcha - 直接回调业务方法:', params.captchaCallback)
      _this[params.captchaCallback](params.captchaParams, captchaData)
    }
  },
  /**
   * @name: closeCaptcha
   * @description: 关闭验证码弹窗
   * @param {type} null
   * @return
  */
  closeCaptcha(type, params) {
    var talPassportCaptcha = document.getElementById('tal-passport-captcha');
    _util.removeElement(talPassportCaptcha)
    if (type == 1) return false
    if (params.captchaParams.closeCaptchaCallback && typeof params.captchaParams.closeCaptchaCallback == 'function') {
      params.captchaParams.closeCaptchaCallback()
    } else {
      window.location.reload()
    }
  },
  /**
   * @name: createToast
   * @description: toast弹窗
   * @param {msg} msg 弹窗提示内容
   * @return
  */
  showPassportToast(msg) {
    var language = configNVCInitParams.language || 'cn'

    // 检查是否已存在 toast，避免重复创建
    var existingToast = document.getElementById('talpassportToast')
    if (existingToast) {
      // 如果已存在，更新内容并重置定时器
      var toastInner = existingToast.querySelector('.tal-passport-toast-inner')
      if (toastInner) {
        toastInner.textContent = msg
      }
      return
    }

    var toast = `<div id="talpassportToast" class="tal-passport-toast-wrap">
                        <div class="tal-passport-toast-inner">`+ msg + `</div>
                    </div>`;

    var toastEle = document.createElement("div");
    toastEle.innerHTML = toast;
    // 判断接入方是否配置将弹窗插入全局或者局部
    if (captchaContent == "") {
      document.body.appendChild(toastEle)
    } else {
      document.getElementById(captchaContent).appendChild(toastEle)
    }
    var talpassportToast = document.getElementById('talpassportToast');
    setTimeout(() => {
      _util.removeElement(talpassportToast)
    }, 2000)
  },
  /**
   * @name: successSubmitCaptcha
   * @description: 提交验证码完成后所需执行方法(清空输入框，提交按钮置灰)
   * @param {无}
   * @return
  */
  successSubmitCaptcha() {
    var talPassportCaptchaFill = document.getElementById('tal-passport-captcha-fill'), // 验证码输入框
      talPassportCaptchaBtn = document.getElementById('tal-passport-captcha-btn'); // 提交按钮

    talPassportCaptchaFill.value = ""
    talPassportCaptchaBtn.setAttribute('disabled', true)
  },
  /*
   * @discribe 滑块失败，调用图形验证处理逻辑方法
   * @method captchaSendFn
   * @param {Object} params 请求参数
   * @param {Object} requestData 请求数据信息
   * @param {Number} captchaData 图形验证场景的数据传参
   * */
  captchaSendFn(params, requestData, captchaData) {
    var language = configNVCInitParams.language || 'cn'
    var _this = this
    // 判断是调出图形验证，还是校验图形验证码发送接口、还是不调用滑块也不校验接口发送，直接调用原接口发送
    if (captchaData.requestType && captchaData.requestType == 1) {

      console.log(requestData, 999)
      // 校验图形验证码接口
      // 重置请求参数
      var setResetParams = {
        data: getParams(params).data || {},
        success: function (res) {
          if (res.errcode == 14104 || res.errcode == 14105) {
            // 图形验证码验证失败的回调，失败之后重新请求获取图形验证码，并且不执行业务方的成功回调

            // toast提示错误信息
            _this.showPassportToast(errMsgLang[language][res.errcode] || res.errmsg)
            // 刷新验证码
            _this.getCaptcha(2, {
              captchaParams: getParams(params),
              captchaCallback: requestData.requestName,
              sceneType: requestData.sceneType,
              uniq_captcha: requestData.uniq_captcha || '',
              host: requestData.host,
              checkToken: requestData.checkToken,
              specialParams: requestData.specialParams
            })
            // 清空输入框，并且提交按钮置灰
            _this.successSubmitCaptcha()
          } else {
            // 调取传递的回调方法
            params.success ? params.success(res) : function (res) { }
          }
        },
        fail: function (fail) {
          params.fail ? params.fail(fail) : function (fail) { }
        },
        complete: function (res) {
          // 请求完成之后设置图形验证提交为可点击状态
          captchaLoding = false
          // loding图标消失
          var loadingBtn = document.getElementById('tal-passport-btn-loading')
          if (loadingBtn) {
            loadingBtn.style.display = 'none'
          }
          if (res.errcode == 14104 || res.errcode == 14105) return false
          // 关闭弹层
          _this.closeCaptcha(1)
          params.complete ? params.complete(res) : function (res) { }
        }
      }
      setResetParams.data.captcha = captchaData.captchaVal || ''
      if (requestData.checkToken) {
        _util.axiosPost(requestData.host + requestData.requestUrl, setResetParams, requestData.specialParams)
      } else {
        _util.axiosPost(requestData.host + requestData.requestUrl, setResetParams)
      }
    } else if (captchaData.requestType && captchaData.requestType == 2) {
      // 滑块在白名单中，不出现滑块也不出现图形验证，直接调用原始接口通过
      if (requestData.checkToken) {
        _util.axiosPost(requestData.host + requestData.requestUrl, params, requestData.specialParams)
      } else {
        _util.axiosPost(requestData.host + requestData.requestUrl, params)
      }
    } else {
      console.log(requestData, 8888888)
      // 调出图形验证，图形验证代替滑块，并且不发送接口请求
      var setCaptchaParams = {
        captchaParams: getParams(params),
        captchaCallback: requestData.requestName,
        sceneType: requestData.sceneType,
        uniq_captcha: requestData.uniq_captcha || '',
        host: requestData.host,
        checkToken: requestData.checkToken,
        specialParams: requestData.specialParams,
        // 保存完整的 requestData，供 submitCaptcha 回调使用
        requestData: requestData
      }
      console.log(setCaptchaParams, '-setCaptchaParams-----')
      // 生产环境可以注释掉滑块参数设置
      setCaptchaParams.captchaParams.data.invisible_sig = ''
      this.getCaptcha(1, setCaptchaParams)
    }
  },
  /*********************暴露axios************************/
  setPassportAxiosRequest(params) {
    if (params.method == 'GET' || params.method == 'get') {
      _util.axiosGet(passport_host_v1 + params.url, params)
    }
    if (params.method == 'POST' || params.method == 'post') {
      _util.axiosPost(passport_host_v1 + params.url, params, params.requestHeaderArr, params.type, params.headersType)
    }
  },
  /*********************微信授权绑定登录开始************************/

  /*
  * @discribe 微信授权
  * @method weChatAuthorize
  * @param {string} params redirect_url 请求参数，重定向地址
  * */
  weChatAuthorize(params) {
    console.log(params, 'params')
    if (!_util.isCheckWeChat()) return params.fail('非微信环境')
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params);
    if (!privateParams.data) {
      privateParams.data = { 'redirect_url': window.location.href }
    }
    if (!privateParams.data.redirect_url) {
      privateParams.data.redirect_url = window.location.href
    }
    _util.axiosPost(passport_host_v1 + '/web/wx/login/redirect', {
      data: privateParams.data || {},
      success: (res) => {
        if (res.errcode == 0) {
          params.success ? params.success(res) : function (res) { }
          if (res.data.url) {
            __udc_ctx = res.data.ctx
            window.location.href = res.data.url
          }
        } else {
          params.fail(res)
        }
      },
      fail: (err) => {
        console.log(err)
      }
    })
  },
  /*
  * @discribe 检测微信授权回调后的参数
  * @method checkWeChatParams
  * @param {string} params redirect_url 请求参数，重定向地址
  * */
  checkWeChatParams(params) {
    console.log(params, 'params00000000')
    var urlParams = _util.getUrlParmas(window.location.href);
    var __udc_ctx = urlParams.__udc_ctx;
    var __udc__wx = urlParams.__udc__wx;
    __udc_ctx = urlParams.__udc_ctx;
    // 如果code值不存在或者非微信环境，不用处理
    if (!__udc__wx || !_util.isCheckWeChat()) return
    if (__udc__wx == 'login') {
      // 直接登录
      this.weChatDirectLogin(params)
    } else if (__udc__wx == 'recommend') {
      // 推荐登录
      this.recommendLogin(params)
    } else if (__udc__wx == 'phone') {
      console.log(params, '手机号登录')
      params.success({
        errcode: 0,
        errmsg: '请求成功',
        data: {
          "__udc__wx": 'phone'
        }
      });
    }
  },
  /*
  * @discribe 直接登录
  * @method weChatDirectLogin
  * @param {string} params redirect_url 请求参数，重定向地址
  * */
  weChatDirectLogin(params) {
    console.log(params, '直接登录')
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params);
    var urlParams = _util.getUrlParmas(window.location.href);
    if (urlParams.__udc_ctx) {
      __udc_ctx = urlParams.__udc_ctx;
    }
    if (!privateParams.data) {
      privateParams['data'] = { 'ctx': __udc_ctx || '' }
    } else {
      privateParams.data['ctx'] = __udc_ctx || ''
    }
    _util.axiosPost(passport_host_v1 + '/web/wx/login', privateParams)
    // _util.axiosPost(passport_host_v1 + '/web/phonecode/get', privateParams)
  },
  /*
  * @discribe 推荐登录获取参数
  * @method recommendLogin
  * @param {string} params redirect_url 请求参数，重定向地址
  * */
  recommendLogin(params) {
    console.log(params, '推荐登录')
    // 暴露tal_id、phone、wx_official_account
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params);
    var urlParams = _util.getUrlParmas(window.location.href);
    if (urlParams.__udc_ctx) {
      __udc_ctx = urlParams.__udc_ctx;
    }
    if (!privateParams.data) {
      privateParams['data'] = { 'ctx': __udc_ctx || '' }
    } else {
      privateParams.data['ctx'] = __udc_ctx || ''
    }
    _util.axiosPost(passport_host_v1 + '/web/wx/login/recommend', privateParams)
  },
  /*********************微信授权绑定登录结束************************/

  /*
  * @discribe 设置实名认证接口
  * @param {params} 参数
  * */
  setCredIdentify: function (params) {
    if (!_util.validResHeader()) return (params.success ? params.success(_util.getCode(1000000)) : '')
    var privateParams = getParams(params)
    this.asyncCheckLogin().then(function (res) {
      var setSpecialParams = {
        isCheckLogin: true,
        name: 'setCredIdentify'
      }
      _util.axiosPost(cg_host_v1 + '/web/user/cred/identify', privateParams, setSpecialParams)
    }).catch(function (fail) {
      // 未登录，接口返回什么就是什么，原封不动返回给业务方
      if (fail.errcode) {
        params.success ? params.success(fail) : function (fail) { }
      } else {
        params.fail ? params.fail(fail) : function (fail) { }
      }
      params.complete ? params.complete(fail) : function (fail) { }
    })
  },
  /*********************魔法校统一商城登录模块 ************************/
  //     /*
  //     * @discribe 验证码登录
  //      * @method loginSms
  //     * @param {params} 参数
  //     * */
  //     orgLoginSms: function(params, captchaData) {
  //       if(!isOrg) {
  //         return params.success ? params.success(_util.getCode(1050001)) : ''
  //       }
  //       if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
  //       var privateParams = getParams(params)
  //       privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
  //       // 验证手机号为空
  //       if (!_util.validNotEmpty(privateParams.data.phone)) {
  //           params.success(_util.getCode(1010006));
  //           return
  //       }
  //       // 验证手机号合法性
  //       if (!_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
  //           params.success(_util.getCode(1010007));
  //           return
  //       }
  //       // 验证手机验证码为空
  //       if (!_util.validNotEmpty(privateParams.data.sms_code)) {
  //           params.success(_util.getCode(1010008));
  //           return
  //       }
  //       // 验证手机号验证码合法性
  //       if (!_util.validVCode(privateParams.data.sms_code)) {
  //           params.success(_util.getCode(1010001));
  //           return
  //       }
  //       var _t = this, _loginRequestUrl = "/web/org/login/sms";
  //       // var urlParams = _util.getUrlParmas(window.location.href);
  //       // if (urlParams.__udc_ctx) {
  //       //     __udc_ctx = urlParams.__udc_ctx;
  //       // }
  //       // if (privateParams.data.bindType == 1) {
  //       //     // 区分是微信登录还是普通登录,bindType为1是微信授权登录接口
  //       //     privateParams.data['ctx'] = __udc_ctx || ''
  //       //     _loginRequestUrl = '/web/wx/login/sms'
  //       // } else if (privateParams.data.bindType == 2) {
  //       //     // 区分是微信换绑登录,bindType为2是微信换绑登录接口
  //       //     _loginRequestUrl = '/web/wx/switch/sms'
  //       // }
  //       function loginSmsInit() {
  //           privateParams.data.source_type = 2
  //           privateParams.data.domain = domain
  //           // 重置请求参数
  //           var setParams = {
  //               data: privateParams.data || {},
  //               success: function(res) {
  //                   // passport登录成功存在一个开启心跳的标识，存在localStorage本地存储中
  //                   if (res.errcode == 0) {
  //                       _util.resetLocalStorage.setItem("tal-passport-open-heartbeat-tag", true);
  //                   }
  //                   // 调取传递的回调方法
  //                   privateParams.success ? privateParams.success(res) : function(res) { }

  //               },
  //               fail: function(fail) {
  //                   privateParams.fail ? privateParams.fail(fail) : function(fail) { }
  //               },
  //               complete: function(res) {
  //                   privateParams.complete ? privateParams.complete(res) : function(res) { }
  //               }
  //           }
  //           _util.axiosPost(passport_host_v1 + _loginRequestUrl, setParams)
  //       }
  //       // 判断是否调用了滑块
  //       if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
  //           // 初始化了滑块，然后判断是否加载完成
  //           window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function(res) {
  //               if (privateParams.data.is_second_verify != 1 && window.ALI_AWSC_INIT_NVC && typeof window.ALI_AWSC_INIT_NVC.getNVCVal === 'function') {
  //                 // 非二次滑块验证，拼接无痕验证签名
  //                 privateParams.data.invisible_sig = window.ALI_AWSC_INIT_NVC.getNVCVal()
  //               }
  //               // 判断是否加载成功
  //               if (!(privateParams.data.invisible_sig)) {
  //                   captchaData = captchaData || {}
  //                   _t.captchaSendFn(privateParams, {
  //                       requestName: 'orgLoginSms',
  //                       requestUrl: _loginRequestUrl,
  //                       sceneType: 2,
  //                       host: passport_host_v1,
  //                       checkToken: false,
  //                       specialParams: {
  //                         isCheckLogin: false
  //                       }
  //                   }, captchaData)
  //                   return false
  //               } else {
  //                   loginSmsInit()
  //               }
  //           })
  //       } else {
  //           loginSmsInit()
  //       }
  //   },

  //     /*
  //     * @discribe 账号密码登录。
  //     * @method orgLoginPassword
  //     * @param {params} 登录参数
  //     * @return {Boolean} 返回一个Promise对象
  //     * */
  //     orgLoginPassword: function(params, captchaData) {
  //       if(!isOrg) {
  //         return params.success ? params.success(_util.getCode(1050001)) : ''
  //       }
  //       if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
  //       var privateParams = getParams(params)
  //       // 验证登录账号不能为空
  //       if (!_util.validNotEmpty(privateParams.data.symbol)) {
  //           params.success(_util.getCode(1010000));
  //           return
  //       }
  //       // 验证密码不能为空
  //       if (!_util.validNotEmpty(privateParams.data.password)) {
  //           params.success(_util.getCode(1010002));
  //           return
  //       }
  //       var _t = this
  //       function loginPasswordInit() {
  //           privateParams.data.source_type = 2
  //           privateParams.data.domain = domain
  //           // 重置请求参数
  //           var setParams = {
  //               data: privateParams.data || {},
  //               success: function(res) {
  //                   // passport登录成功存在一个开启心跳的标识，存在localStorage本地存储中
  //                   if (res.errcode == 0) {
  //                       _util.resetLocalStorage.setItem("tal-passport-open-heartbeat-tag", true);
  //                   }
  //                   // 调取传递的回调方法
  //                   privateParams.success ? privateParams.success(res) : function(res) { }

  //               },
  //               fail: function(fail) {
  //                   privateParams.fail ? privateParams.fail(fail) : function(fail) { }
  //               },
  //               complete: function(res) {
  //                   privateParams.complete ? privateParams.complete(res) : function(res) { }
  //               }
  //           }
  //           _util.axiosPost(passport_host_v1 + '/web/org/login/pwd', setParams)
  //       }
  //       // 判断是否调用了滑块
  //       if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
  //           // 初始化了滑块，然后判断是否加载完成
  //           window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function(res) {
  //               if (privateParams.data.is_second_verify != 1 && window.ALI_AWSC_INIT_NVC && typeof window.ALI_AWSC_INIT_NVC.getNVCVal === 'function') {
  //                 // 非二次滑块验证，拼接无痕验证签名
  //                 privateParams.data.invisible_sig = window.ALI_AWSC_INIT_NVC.getNVCVal()
  //               }
  //               // 判断是否加载成功
  //               if (!(privateParams.data.invisible_sig)) {
  //                   captchaData = captchaData || {}
  //                   _t.captchaSendFn(privateParams, {
  //                       requestName: 'orgLoginPassword',
  //                       requestUrl: '/web/org/login/pwd',
  //                       sceneType: 3,
  //                       host: passport_host_v1,
  //                       checkToken: false,
  //                       specialParams: {
  //                         isCheckLogin: false
  //                       }
  //                   }, captchaData)
  //                   return false
  //               } else {
  //                   loginPasswordInit()
  //               }
  //           })
  //       } else {
  //           loginPasswordInit()
  //       }
  //   },
  //   /*
  //     * @discribe 机构确认登录
  //     * @method orgSelectConfirm
  //     * @param {params} 参数
  //     * @return {Promise} 返回一个Promise对象
  //     * */
  //   orgSelectConfirm: function(params, captchaData) {
  //     if(!isOrg) {
  //       return params.success ? params.success(_util.getCode(1050001)) : ''
  //     }
  //     if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
  //     var privateParams = getParams(params)
  //     // 机构id不为空
  //     if (!_util.validNotEmpty(params.data.org_id)) {
  //       params.success(_util.getCode(1040006));
  //       return
  //     }
  //     // 机构id不为空
  //     if (!_util.validNotEmpty(params.data.code)) {
  //       params.success(_util.getCode(1040006));
  //       return
  //     }
  //     var _t = this
  //     function orgSelectInit() {
  //         // privateParams.data.source_type = 2
  //         // privateParams.data.domain = domain
  //         // 重置请求参数
  //         var setParams = {
  //             data: privateParams.data || {},
  //             success: function(res) {
  //                 // passport登录成功存在一个开启心跳的标识，存在localStorage本地存储中
  //                 if (res.errcode == 0) {
  //                     _util.resetLocalStorage.setItem("tal-passport-open-heartbeat-tag", true);
  //                 }
  //                 // 调取传递的回调方法
  //                 privateParams.success ? privateParams.success(res) : function(res) { }

  //             },
  //             fail: function(fail) {
  //                 privateParams.fail ? privateParams.fail(fail) : function(fail) { }
  //             },
  //             complete: function(res) {
  //                 privateParams.complete ? privateParams.complete(res) : function(res) { }
  //             }
  //         }
  //         _util.axiosPost(passport_host_v1 + '/web/org/login/select', setParams)
  //     }
  //     // 判断是否调用了滑块
  //     if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
  //         // 初始化了滑块，然后判断是否加载完成
  //         window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function(res) {
  //             if (privateParams.data.is_second_verify != 1 && window.ALI_AWSC_INIT_NVC && typeof window.ALI_AWSC_INIT_NVC.getNVCVal === 'function') {
  //               // 非二次滑块验证，拼接无痕验证签名
  //               privateParams.data.invisible_sig = window.ALI_AWSC_INIT_NVC.getNVCVal()
  //             }
  //             // 判断是否加载成功
  //             if (!(privateParams.data.invisible_sig)) {
  //                 captchaData = captchaData || {}
  //                 _t.captchaSendFn(privateParams, {
  //                     requestName: 'orgSelectConfirm',
  //                     requestUrl: '/web/org/login/select',
  //                     sceneType: 3,  //获取图形验证码场景
  //                     host: passport_host_v1,
  //                     checkToken: false,
  //                     specialParams: {
  //                       isCheckLogin: false
  //                     }
  //                 }, captchaData)
  //                 return false
  //             } else {
  //               orgSelectInit()
  //             }
  //         })
  //     } else {
  //       orgSelectInit()
  //     }
  // },
  //   /*
  //     * @discribe 获取机构列表
  //     * @method getOrgList
  //     * @param {params} 参数
  //     * @return {Promise} 返回一个Promise对象
  //     * */
  //   getOrgList: function(params) {
  //     if(!isOrg) {
  //       return params.success ? params.success(_util.getCode(1050001)) : ''
  //     }
  //     if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
  //     var privateParams = getParams(params)
  //     _util.axiosGet(passport_host_v1 + '/web/org/login/list', privateParams)
  //   },
  //   /*
  //     * @discribe 登录机构切换
  //     * @method switchOrgLogin
  //     * @param {params} 参数
  //     * @return {Promise} 返回一个Promise对象
  //     * */
  //   switchOrgLogin: function(params) {
  //     if(!isOrg) {
  //       return params.success ? params.success(_util.getCode(1050001)) : ''
  //     }
  //     if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
  //     // 机构id不为空
  //     if (!_util.validNotEmpty(params.data.org_id)) {
  //       params.success(_util.getCode(1040006));
  //       return
  //     }
  //     var privateParams = getParams(params)
  //     _util.axiosGet(passport_host_v1 + '/web/org/login/switch', privateParams)
  //   },
  //   /*********************魔法校统一商城机构创建模块 ************************/
  //   /*
  //   * @discribe 创建机构
  //     @method createOrgFn
  //   * @param {params} 参数
  //   * */
  //   createOrgFn(params){
  //     console.log(params)
  //     var privateParams = getParams(params)
  //     if(!isOrg) {
  //       return params.success ? params.success(_util.getCode(1050001)) : ''
  //     }
  //     // 机构名称不为空
  //     if (!_util.validNotEmpty(privateParams.data.org_short_name)) {
  //       params.success(_util.getCode(1010000));
  //       return
  //     }
  //     // 验证机构名称合法性
  //     if (privateParams.data.org_short_name.length > 25) {
  //       return params.success(_util.getCode(1030004))
  //     }
  //     // 机构管理员 手机国家码不为空
  //     if (!_util.validNotEmpty(privateParams.data.owner_phone_code)) {
  //       params.success(_util.getCode(1050002));
  //       return
  //     }
  //     // 机构管理员  手机号不为空
  //     if (!_util.validNotEmpty(privateParams.data.owner_phone)) {
  //       params.success(_util.getCode(1050003));
  //       return
  //     }
  //       // 验证省份信息合法性
  //       if (privateParams.data.province && privateParams.data.province <= 0) {
  //           return params.success(_util.getCode(1040000))
  //       }
  //       // 验证城市信息合法性
  //       if (privateParams.data.city && privateParams.data.city <= 0) {
  //           return params.success(_util.getCode(1040001))
  //       }
  //       // 验证区县信息合法性
  //       if (privateParams.data.county && privateParams.data.county <= 0) {
  //           return params.success(_util.getCode(1040002))
  //       }
  //       // 验证收货地址详细信息合法性
  //       if (privateParams.data.detail && privateParams.data.detail.length > 100) {
  //           return params.success(_util.getCode(1030003))
  //       }
  //       // var regName = /^[a-z0-9A-Z&\-,（）(). \u4e00-\u9fa5]+$/;
  //       // if (!regName.test(privateParams.data.realname)) {
  //       //     return params.success(_util.getCode(1020002))
  //       // }
  //       /*验证32位*/
  //       // if (privateParams.data.realname.length > 32) {
  //       //     return params.success(_util.getCode(1020002))
  //       // }
  //     if (_util.validEmpty(privateParams.data.founder_name)) {
  //         return params.success(_util.getCode(1020002))
  //     }
  //     if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
  //     console.log(123)
  //     var privateParams = getParams(params);
  //     console.log(privateParams,'privateParams')
  //     _util.axiosPost(passport_host_v1 + '/web/org/create', privateParams)
  //   },
  //     /*
  //   * @discribe 机构信息详情
  //     @method orgInfoDetail
  //   * @param {params} 参数
  //   * */
  //   orgInfoDetail(params){
  //     if(!isOrg) {
  //       return params.success ? params.success(_util.getCode(1050001)) : ''
  //     }
  //     console.log(params,'params')
  //     if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
  //     var privateParams = getParams(params);
  //     console.log(privateParams,'privateParams')
  //     _util.axiosPost(passport_host_v1 + '/web/org/detail', privateParams)

  //   },
  //   /*********************魔法校统一商城员工模块 ************************/
  //    /*
  //   * @discribe 删除员工/退出机构
  //     @method delOrgUser
  //   * @param {params} 参数
  //   * */
  //   userExitOrg(params){
  //     if(!isOrg) {
  //       return params.success ? params.success(_util.getCode(1050001)) : ''
  //     }
  //     if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
  //     var privateParams = getParams(params);
  //     console.log(privateParams,'privateParams')
  //     _util.axiosPost(passport_host_v1 + '/web/org/user/exit', privateParams)

  //   },
  //   /*
  //   * @discribe 员工信息详情
  //     @method userInfoDetail
  //   * @param {params} 参数
  //   * */
  //     userInfoDetail(params){
  //       if(!isOrg) {
  //         return params.success ? params.success(_util.getCode(1050001)) : ''
  //       }
  //       if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
  //       var privateParams = getParams(params);
  //       _util.axiosPost(passport_host_v1 + '/web/org/user/detail', privateParams)

  //     },
  //     /*
  //     * @discribe 员工信息变更
  //       @method userInfoSwitch
  //     * @param {params} 参数
  //     * */
  //     userInfoModify(params){
  //       if(!isOrg) {
  //         return params.success ? params.success(_util.getCode(1050001)) : ''
  //       }
  //       if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
  //       var privateParams = getParams(params);
  //       // 判断有头像上传字段时先上传头像再进行信息变更
  //       if(privateParams.data.image){
  //         var allowArr = ['png', 'jpg', 'jpeg', 'gif'];
  //         var type = params.data.image.type
  //         var imgType = type.split('/')[1]
  //         if (allowArr.indexOf(imgType.toLocaleLowerCase()) == -1) {
  //             return params.success(_util.getCode(1020006))
  //         }
  //         var formData = new FormData();
  //         for (var i in params.data) {
  //             formData.append(i, params.data[i])
  //         }
  //         params.data = formData
  //         this.asyncCheckLogin().then(function(res){
  //           var setSpecialParams = {
  //             isCheckLogin: true,
  //             type: 'formdata',
  //             headersType: reqMultipart,
  //             name: 'image'
  //           }
  //           _util.axiosPost(passport_host_v1 + '/web/user/avatar/upload', {
  //             data: params.data,
  //             success: (res) => {
  //               if(res.errcode==0){
  //                 privateParams.data['avatar_url'] = res.data.avatar_url
  //                 _util.axiosPost(passport_host_v1 + '/web/org/user/modify', privateParams)
  //               }
  //             },
  //           },setSpecialParams)
  //         }).catch(function(fail){
  //           // 未登录，接口返回什么就是什么，原封不动返回给业务方
  //           if (fail.errcode) {
  //             params.success ? params.success(fail) : function (fail) {}
  //           } else {
  //             params.fail ? params.fail(fail) : function (fail) {}
  //           }
  //           params.complete ? params.complete(fail) : function (fail) {}
  //         })


  //       }else{
  //         _util.axiosPost(passport_host_v1 + '/web/org/user/modify', privateParams)
  //       }
  //     },
  /*
  * @discribe 游客登录
    @method userInfoSwitch
  * @param {params} 参数
  * */
  touristLogin(params, captchaData) {
    console.log('touristLogin 被调用, captchaData:', captchaData)

    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))

    var privateParams = getParams(params)
    privateParams.data.uniq_captcha = uniqCaptcha

    var _t = this;
    var set_host = passport_host_v1;
    var is_token = false; // touristLogin 不需要登录态
    // 设置特殊参数
    var setSpecialParams = {
      isCheckLogin: false,
      name: 'touristLogin'
    }

    var sendRequest = function (captchaVerifyParam) {
      console.log('touristLogin sendRequest 被调用, captchaVerifyParam:', captchaVerifyParam)
      // 只有当 captchaVerifyParam 是字符串类型时，才认为是阿里无感验证码数据
      // 图形验证码数据是对象类型 {requestType: 1, captchaVal: '...'}
      if (captchaVerifyParam && typeof captchaVerifyParam === 'string') {
        try {
          let captchaVerifyParamObj = JSON.parse(captchaVerifyParam);
          // 确认包含 sceneId 字段，进一步确保是阿里验证码数据
          if (captchaVerifyParamObj && captchaVerifyParamObj.sceneId) {
            privateParams.data.invisible_sig = captchaVerifyParam;
            privateParams.data.invisible_sig_scene = captchaVerifyParamObj.sceneId;
            console.log('touristLogin - 设置阿里无感验证码参数')
          }
        } catch (e) {
          console.warn('touristLogin - 解析验证码参数失败:', e)
        }
      }
      console.log('touristLogin 准备发送请求, 请求参数:', privateParams.data)

      // 重置请求参数
      var setParams = {
        data: privateParams.data || {},
        success: function (res) {
          // passport登录成功存在一个开启心跳的标识，存在localStorage本地存储中
          if (res.errcode == 0) {
            _util.resetLocalStorage.setItem("tal-passport-open-heartbeat-tag", true);
          }
          // 调取传递的回调方法
          privateParams.success ? privateParams.success(res) : function (res) { }
        },
        fail: function (fail) {
          privateParams.fail ? privateParams.fail(fail) : function (fail) { }
        },
        complete: function (res) {
          privateParams.complete ? privateParams.complete(res) : function (res) { }
        }
      }
      _util.axiosPost(set_host + '/web/login/tourist', setParams)
    }

    // 如果是第二次校验（已经通过滑块验证），直接调用接口
    console.log('touristLogin 判断是否已有验证数据: is_second_verify=', privateParams.data.is_second_verify, 'captchaData=', captchaData)
    if (captchaData) {
      console.log('touristLogin - 已有验证数据，直接发送请求')
      sendRequest(captchaData)
      return
    }

    console.log('touristLogin 未检测到验证数据，准备触发滑块')
    // 判断是否初始化滑块
    if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
      console.log('touristLogin - 开始等待阿里验证码初始化')
      window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function (res) {
        console.log('touristLogin - 阿里验证码初始化完成', res)

        // 检查阿里验证码是否加载成功
        if (res && res.status === 'fail') {
          // 阿里验证码加载失败，降级到图形验证码
          console.log('阿里验证码加载失败，降级使用图形验证码', res.reason)
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'touristLogin',
            requestUrl: '/web/login/tourist',
            sceneType: 7,  //获取图形验证码场景
            host: set_host,
            uniq_captcha: uniqCaptcha,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
          return;
        }

        // 阿里风控2.0能力调用
        if (window.initAliyunCaptcha) {
          console.log('touristLogin - 触发阿里验证码')
          // 保存上下文，用于滑块成功后回调
          sdkCallbackContext = {
            method: 'touristLogin',
            params: params,
            captchaData: null
          };
          // 触发阿里滑块按钮点击
          document.getElementById('tal-udc-captcha-button-for-aliyun').click()
          console.log('touristLogin - 触发阿里验证码成功=====并点击了按钮')
        } else {
          // 没有 initAliyunCaptcha 方法，使用图形验证码
          console.log('touristLogin - 使用图形验证码')
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'touristLogin',
            requestUrl: '/web/login/tourist',
            sceneType: 7,  //获取图形验证码场景
            host: set_host,
            uniq_captcha: uniqCaptcha,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
        }
      }).catch(function(err) {
        // Promise 异常，降级到图形验证码
        console.error('阿里验证码初始化异常，降级使用图形验证码', err)
        captchaData = captchaData || {}
        _t.captchaSendFn(privateParams, {
          requestName: 'touristLogin',
          requestUrl: '/web/login/tourist',
          sceneType: 7,  //获取图形验证码场景
          host: set_host,
          uniq_captcha: uniqCaptcha,
          checkToken: is_token,
          specialParams: setSpecialParams
        }, captchaData)
      })
    } else {
      // 没有初始化滑块，直接发送请求
      console.log('touristLogin 没有初始化滑块配置，直接发送请求')
      sendRequest()
    }
  },
  //----------------- 跨应用登录-------------------------------//
  /*
  * @discribe 获取转移码
    @method getTransferCode
  * @param {params} 参数
  * */
  getTransferCode(params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params);
    _util.axiosPost(passport_host_v1 + '/web/login/transfer/code/get', privateParams)

  },
  /*
 * @discribe 获取授权结果
   @method getTransferCodeStatus
 * @param {params} 参数
 * */
  getTransferCodeStatus(params) {
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params);
    _util.axiosPost(passport_host_v1 + '/web/login/transfer/code/status', privateParams)

  },
  //----------------- 邮箱注册模块-------------------------------//
  /*
  * @discribe 邮箱发送验证码（阿里验证码2.0风控）
    @method sendEmailRegCode
  * @param {params} 参数
  * @param {Object} captchaData 图形验证场景的数据传参
  * */
  sendEmailRegCode(params, captchaData) {
    console.log('sendEmailRegCode 被调用, captchaData:', captchaData)

    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))

    var pattern = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
    var privateParams = getParams(params)

    // 验证邮箱格式
    if (!pattern.test(privateParams.data.email)) {
      return params.success(_util.getCode(1010018))
    }

    var _t = this;
    var set_host = passport_host_v1;
    var is_token = false; // 邮箱注册不需要登录态
    // 设置特殊参数
    var setSpecialParams = {
      isCheckLogin: false,
      name: 'sendEmailRegCode'
    }

    var sendRequest = function (captchaVerifyParam) {
      console.log('sendEmailRegCode sendRequest 被调用, captchaVerifyParam:', captchaVerifyParam)
      // 只有当 captchaVerifyParam 是字符串类型时，才认为是阿里无感验证码数据
      // 图形验证码数据是对象类型 {requestType: 1, captchaVal: '...'}
      if (captchaVerifyParam && typeof captchaVerifyParam === 'string') {
        try {
          let captchaVerifyParamObj = JSON.parse(captchaVerifyParam);
          // 确认包含 sceneId 字段，进一步确保是阿里验证码数据
          if (captchaVerifyParamObj && captchaVerifyParamObj.sceneId) {
            privateParams.data.invisible_sig = captchaVerifyParam;
            privateParams.data.invisible_sig_scene = captchaVerifyParamObj.sceneId;
            console.log('sendEmailRegCode - 设置阿里无感验证码参数')
          }
        } catch (e) {
          console.warn('sendEmailRegCode - 解析验证码参数失败:', e)
        }
      }
      console.log('sendEmailRegCode 准备发送请求, 请求参数:', privateParams.data)

      // 重置请求参数
      var setParams = {
        data: privateParams.data || {},
        success: function (res) {
          // passport登录成功存在一个开启心跳的标识，存在localStorage本地存储中
          if (res.errcode == 0) {
            _util.resetLocalStorage.setItem("tal-passport-open-heartbeat-tag", true);
          }
          // 调取传递的回调方法
          privateParams.success ? privateParams.success(res) : function (res) { }
        },
        fail: function (fail) {
          privateParams.fail ? privateParams.fail(fail) : function (fail) { }
        },
        complete: function (res) {
          privateParams.complete ? privateParams.complete(res) : function (res) { }
        }
      }
      _util.axiosPost(set_host + '/web/reg/email/send', setParams)
    }

    // 如果是第二次校验（已经通过滑块验证），直接调用接口
    console.log('sendEmailRegCode 判断是否已有验证数据: is_second_verify=', privateParams.data.is_second_verify, 'captchaData=', captchaData)
    if (captchaData) {
      console.log('sendEmailRegCode - 已有验证数据，直接发送请求')
      sendRequest(captchaData)
      return
    }

    console.log('sendEmailRegCode 未检测到验证数据，准备触发滑块')
    // 判断是否初始化滑块
    if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
      console.log('sendEmailRegCode - 开始等待阿里验证码初始化')
      window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function (res) {
        console.log('sendEmailRegCode - 阿里验证码初始化完成', res)

        // 检查阿里验证码是否加载成功
        if (res && res.status === 'fail') {
          // 阿里验证码加载失败，降级到图形验证码
          console.log('阿里验证码加载失败，降级使用图形验证码', res.reason)
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'sendEmailRegCode',
            requestUrl: '/web/reg/email/send',
            sceneType: 7, // 邮箱注册验证码场景
            host: set_host,
            uniq_captcha: uniqCaptcha,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
          return;
        }

        // 阿里风控2.0能力调用
        if (window.initAliyunCaptcha) {
          console.log('sendEmailRegCode - 触发阿里验证码')
          // 保存上下文，用于滑块成功后回调
          sdkCallbackContext = {
            method: 'sendEmailRegCode',
            params: params,
            captchaData: null
          };
          // 触发阿里滑块按钮点击
          document.getElementById('tal-udc-captcha-button-for-aliyun').click()
          console.log('sendEmailRegCode - 触发阿里验证码成功=====并点击了按钮')
        } else {
          // 没有 initAliyunCaptcha 方法，使用图形验证码
          console.log('sendEmailRegCode - 使用图形验证码')
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'sendEmailRegCode',
            requestUrl: '/web/reg/email/send',
            sceneType: 7, // 邮箱注册验证码场景
            host: set_host,
            uniq_captcha: uniqCaptcha,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
        }
      }).catch(function(err) {
        // Promise 异常，降级到图形验证码
        console.error('阿里验证码初始化异常，降级使用图形验证码', err)
        captchaData = captchaData || {}
        _t.captchaSendFn(privateParams, {
          requestName: 'sendEmailRegCode',
          requestUrl: '/web/reg/email/send',
          sceneType: 7, // 邮箱注册验证码场景
          host: set_host,
          uniq_captcha: uniqCaptcha,
          checkToken: is_token,
          specialParams: setSpecialParams
        }, captchaData)
      })
    } else {
      // 没有初始化滑块，直接发送请求
      console.log('sendEmailRegCode 没有初始化滑块配置，直接发送请求')
      sendRequest()
    }
  },
  /*
  * @discribe 邮箱注册
    @method sendEmailRegCode
  * @param {params} 参数
  * */
  emailCodeReg(params, captchaData) {
    // console.log(_util.createdDId(),'_util.createdDId()')
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    // var pattern = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;

    var privateParams = getParams(params)
    if (!emailRegular.test(privateParams.data.email)) {
      return params.success(_util.getCode(1010018))
    }
    var _t = this
    function emailCodeRegInit() {
      // privateParams.data.source_type = 2
      // privateParams.data.domain = domain
      // 重置请求参数
      var setParams = {
        data: privateParams.data || {},
        success: function (res) {
          // passport登录成功存在一个开启心跳的标识，存在localStorage本地存储中
          if (res.errcode == 0) {
            _util.resetLocalStorage.setItem("tal-passport-open-heartbeat-tag", true);
          }
          // 调取传递的回调方法
          privateParams.success ? privateParams.success(res) : function (res) { }

        },
        fail: function (fail) {
          privateParams.fail ? privateParams.fail(fail) : function (fail) { }
        },
        complete: function (res) {
          privateParams.complete ? privateParams.complete(res) : function (res) { }
        }
      }
      _util.axiosPost(passport_host_v1 + '/web/reg/email', setParams)
    }
    // 判断是否调用了滑块
    if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
      // 初始化了滑块，然后判断是否加载完成
      window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function (res) {
        if (privateParams.data.is_second_verify != 1 && window.ALI_AWSC_INIT_NVC && typeof window.ALI_AWSC_INIT_NVC.getNVCVal === 'function') {
          // 非二次滑块验证，拼接无痕验证签名
          privateParams.data.invisible_sig = window.ALI_AWSC_INIT_NVC.getNVCVal()
        }
        // 判断是否加载成功
        if (!(privateParams.data.invisible_sig)) {
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'emailCodeReg',
            requestUrl: '/web/reg/email',
            sceneType: 7,  //获取图形验证码场景
            host: passport_host_v1,
            uniq_captcha: uniqCaptcha,
            checkToken: false,
            specialParams: {
              isCheckLogin: false
            }
          }, captchaData)
          return false
        } else {
          emailCodeRegInit()
        }
      })
    } else {
      emailCodeRegInit()
    }
  },

  /*
 * @discribe 密码、邮箱修改获取验证码（阿里验证码2.0风控）
 * @method sendEmailCode
 * @param {params} 参数 type: 0 登录 1 找回密码 2 设置密码
 * @param {Object} captchaData 图形验证场景的数据传参
 * @return {Boolean} 返回一个Promise对象
 * */
  sendEmailCode: function (params, captchaData) {
    console.log('sendEmailCode 被调用, captchaData:', captchaData)

    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))

    var privateParams = getParams(params)
    // 验证邮箱 为空
    if ((privateParams.data.use == 8 || privateParams.data.use == 11) && !_util.validNotEmpty(privateParams.data.email)) {
      params.success(_util.getCode(1010017))
      return
    }

    var _t = this;
    var set_host = passport_host_v1
    var is_token = false
    // use 为5、6、7时需要登录态，4、8找回密码不需要登录态
    if (privateParams.data && (privateParams.data.use == 5 || privateParams.data.use == 6 || privateParams.data.use == 7 || privateParams.data.use == 9 || privateParams.data.use == 10 || privateParams.data.use == 11)) {
      set_host = cg_host_v1
      is_token = true
    }
    // 设置需要登录态的特殊参数
    var setSpecialParams = {
      isCheckLogin: true,
      name: 'sendEmailCode'
    }

    var sendRequest = function (captchaVerifyParam) {
      console.log('sendEmailCode sendRequest 被调用, captchaVerifyParam:', captchaVerifyParam)
      // 只有当 captchaVerifyParam 是字符串类型时，才认为是阿里无感验证码数据
      // 图形验证码数据是对象类型 {requestType: 1, captchaVal: '...'}
      if (captchaVerifyParam && typeof captchaVerifyParam === 'string') {
        try {
          let captchaVerifyParamObj = JSON.parse(captchaVerifyParam);
          // 确认包含 sceneId 字段，进一步确保是阿里验证码数据
          if (captchaVerifyParamObj && captchaVerifyParamObj.sceneId) {
            privateParams.data.invisible_sig = captchaVerifyParam;
            privateParams.data.invisible_sig_scene = captchaVerifyParamObj.sceneId;
            console.log('sendEmailCode - 设置阿里无感验证码参数')
          }
        } catch (e) {
          console.warn('sendEmailCode - 解析验证码参数失败:', e)
        }
      }
      console.log('sendEmailCode 准备发送请求, 请求参数:', privateParams.data)
      if (is_token) {
        _t.asyncCheckLogin().then(function (res) {
          _util.axiosPost(set_host + '/web/security/email/send', privateParams, setSpecialParams)
        }).catch(function (fail) {
          // 未登录，接口返回什么就是什么，原封不动返回给业务方
          if (fail.errcode) {
            params.success ? params.success(fail) : function (fail) { }
          } else {
            params.fail ? params.fail(fail) : function (fail) { }
          }
          params.complete ? params.complete(fail) : function (fail) { }
        })
      } else {
        _util.axiosPost(set_host + '/web/security/email/send', privateParams)
      }
    }

    // 如果是第二次校验（已经通过滑块验证），直接调用接口
    console.log('sendEmailCode 判断是否已有验证数据: is_second_verify=', privateParams.data.is_second_verify, 'captchaData=', captchaData)
    if (captchaData) {
      console.log('sendEmailCode - 已有验证数据，直接发送请求')
      sendRequest(captchaData)
      return
    }

    console.log('sendEmailCode 未检测到验证数据，准备触发滑块')
    // 判断是否初始化滑块
    if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
      console.log('sendEmailCode - 开始等待阿里验证码初始化')
      window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function (res) {
        console.log('sendEmailCode - 阿里验证码初始化完成', res)

        // 检查阿里验证码是否加载成功
        if (res && res.status === 'fail') {
          // 阿里验证码加载失败，降级到图形验证码
          console.log('阿里验证码加载失败，降级使用图形验证码', res.reason)
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'sendEmailCode',
            requestUrl: '/web/security/email/send',
            sceneType: 4,
            host: set_host,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
          return;
        }

        // 阿里风控2.0能力调用
        if (window.initAliyunCaptcha) {
          console.log('sendEmailCode - 触发阿里验证码')
          // 保存上下文，用于滑块成功后回调
          sdkCallbackContext = {
            method: 'sendEmailCode',
            params: params,
            captchaData: null
          };
          // 触发阿里滑块按钮点击
          document.getElementById('tal-udc-captcha-button-for-aliyun').click()
          console.log('sendEmailCode - 触发阿里验证码成功=====并点击了按钮')
        } else {
          // 没有 initAliyunCaptcha 方法，使用图形验证码
          console.log('sendEmailCode - 使用图形验证码')
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'sendEmailCode',
            requestUrl: '/web/security/email/send',
            sceneType: 4,
            host: set_host,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
        }
      }).catch(function(err) {
        // Promise 异常，降级到图形验证码
        console.error('阿里验证码初始化异常，降级使用图形验证码', err)
        captchaData = captchaData || {}
        _t.captchaSendFn(privateParams, {
          requestName: 'sendEmailCode',
          requestUrl: '/web/security/email/send',
          sceneType: 4,
          host: set_host,
          checkToken: is_token,
          specialParams: setSpecialParams
        }, captchaData)
      })
    } else {
      // 没有初始化滑块，直接发送请求
      console.log('sendEmailCode 没有初始化滑块配置，直接发送请求')
      sendRequest()
    }
  },
  /*
 * @discribe 忘记密码，验证旧邮箱
 * @method checkPhone
 * @param {params} 参数
 * @return {Boolean} 返回一个Promise对象
 * */
  checkEmail: function (params) {
    console.log(params, 'params======')
    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params)
    // 验证类型不能为空
    if (!privateParams.data.type) {
      return params.success(_util.getCode(1010005))
    }
    if (privateParams.data.type == 8) {
      // 忘记密码
      // privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
      // 验证手机号为空
      if (!_util.validNotEmpty(privateParams.data.email)) {
        params.success(_util.getCode(1010012));
        return
      }
      // 验证邮箱合法性
      if (!_util.validPhone(privateParams.data.email)) {
        params.success(_util.getCode(1010017));
        return
      }
      if (!emailRegular.test(privateParams.data.email)) {
        return params.success(_util.getCode(1010018))
      }
    }
    // 验证验证码为空
    if (!_util.validNotEmpty(privateParams.data.vcode)) {
      params.success(_util.getCode(1010009));
      return
    }
    // 验证合法性
    if (!_util.validVCode(privateParams.data.vcode)) {
      params.success(_util.getCode(1010013));
      return
    }
    if (privateParams.data.is_second_verify != 1 && window.ALI_AWSC_INIT_NVC && typeof window.ALI_AWSC_INIT_NVC.getNVCVal === 'function') {
      // 非二次滑块验证，拼接无痕验证签名
      privateParams.data.invisible_sig = window.ALI_AWSC_INIT_NVC.getNVCVal()
    }
    // 判断是否需要登录态
    if (privateParams.data.type == 9 || privateParams.data.type == 10) {
      // 换绑手机号和登录态下修改密码，需要登录态
      var setSpecialParams = {
        isCheckLogin: true,
        name: 'checkEmail'
      }
      this.asyncCheckLogin().then(function (res) {
        _util.axiosPost(cg_host_v1 + '/web/security/email/check', privateParams, setSpecialParams)
      }).catch(function (fail) {
        // 未登录，接口返回什么就是什么，原封不动返回给业务方
        if (fail.errcode) {
          params.success ? params.success(fail) : function (fail) { }
        } else {
          params.fail ? params.fail(fail) : function (fail) { }
        }
        params.complete ? params.complete(fail) : function (fail) { }
      })
    } else {
      // 忘记密码，不需要登录态
      _util.axiosPost(passport_host_v1 + '/web/security/email/check', privateParams)
    }
  },

  /*
  * @discribe 换绑邮箱（阿里验证码2.0风控）
  * @method changeEmail
  * @param {params} 参数
  * @param {Object} captchaData 图形验证场景的数据传参
  * @return {Boolean} 返回一个Promise对象
  * */
  changeEmail: function (params, captchaData) {
    console.log('changeEmail 被调用, captchaData:', captchaData)

    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))

    var privateParams = getParams(params);
    // 验证邮箱为空
    if (!_util.validNotEmpty(privateParams.data.email)) {
      params.success(_util.getCode(1010017));
      return
    }
    // 验证邮箱合法性
    if (!_util.validPhone(privateParams.data.email)) {
      params.success(_util.getCode(1010017));
      return
    }
    if (!emailRegular.test(privateParams.data.email)) {
      return params.success(_util.getCode(1010018))
    }
    // 验证验证码为空
    if (!_util.validNotEmpty(privateParams.data.vcode)) {
      params.success(_util.getCode(1010009));
      return
    }
    // 验证验证码合法性
    if (!_util.validVCode(privateParams.data.vcode)) {
      params.success(_util.getCode(1010016));
      return
    }
    // 验证TAG不能为空
    if (!_util.validNotEmpty(privateParams.data.tag)) {
      params.success(_util.getCode(1010003));
      return
    }

    var _t = this;
    var set_host = cg_host_v1;
    var is_token = true; // changeEmail 需要登录态
    // 设置需要登录态的特殊参数
    var setSpecialParams = {
      isCheckLogin: true,
      name: 'changeEmail'
    }

    var sendRequest = function (captchaVerifyParam) {
      console.log('changeEmail sendRequest 被调用, captchaVerifyParam:', captchaVerifyParam)
      // 只有当 captchaVerifyParam 是字符串类型时，才认为是阿里无感验证码数据
      // 图形验证码数据是对象类型 {requestType: 1, captchaVal: '...'}
      if (captchaVerifyParam && typeof captchaVerifyParam === 'string') {
        try {
          let captchaVerifyParamObj = JSON.parse(captchaVerifyParam);
          // 确认包含 sceneId 字段，进一步确保是阿里验证码数据
          if (captchaVerifyParamObj && captchaVerifyParamObj.sceneId) {
            privateParams.data.invisible_sig = captchaVerifyParam;
            privateParams.data.invisible_sig_scene = captchaVerifyParamObj.sceneId;
            console.log('changeEmail - 设置阿里无感验证码参数')
          }
        } catch (e) {
          console.warn('changeEmail - 解析验证码参数失败:', e)
        }
      }
      console.log('changeEmail 准备发送请求, 请求参数:', privateParams.data)

      _t.asyncCheckLogin().then(function (res) {
        _util.axiosPost(set_host + '/web/security/email/update', privateParams, setSpecialParams)
      }).catch(function (fail) {
        // 未登录，接口返回什么就是什么，原封不动返回给业务方
        if (fail.errcode) {
          params.success ? params.success(fail) : function (fail) { }
        } else {
          params.fail ? params.fail(fail) : function (fail) { }
        }
        params.complete ? params.complete(fail) : function (fail) { }
      })
    }

    // 如果是第二次校验（已经通过滑块验证），直接调用接口
    console.log('changeEmail 判断是否已有验证数据: is_second_verify=', privateParams.data.is_second_verify, 'captchaData=', captchaData)
    if (captchaData) {
      console.log('changeEmail - 已有验证数据，直接发送请求')
      sendRequest(captchaData)
      return
    }

    console.log('changeEmail 未检测到验证数据，准备触发滑块')
    // 判断是否初始化滑块
    if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
      console.log('changeEmail - 开始等待阿里验证码初始化')
      window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function (res) {
        console.log('changeEmail - 阿里验证码初始化完成', res)

        // 检查阿里验证码是否加载成功
        if (res && res.status === 'fail') {
          // 阿里验证码加载失败，降级到图形验证码
          console.log('阿里验证码加载失败，降级使用图形验证码', res.reason)
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'changeEmail',
            requestUrl: '/web/security/email/update',
            sceneType: 9, // 邮箱换绑场景
            host: set_host,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
          return;
        }

        // 阿里风控2.0能力调用
        if (window.initAliyunCaptcha) {
          console.log('changeEmail - 触发阿里验证码')
          // 保存上下文，用于滑块成功后回调
          sdkCallbackContext = {
            method: 'changeEmail',
            params: params,
            captchaData: null
          };
          // 触发阿里滑块按钮点击
          document.getElementById('tal-udc-captcha-button-for-aliyun').click()
          console.log('changeEmail - 触发阿里验证码成功=====并点击了按钮')
        } else {
          // 没有 initAliyunCaptcha 方法，使用图形验证码
          console.log('changeEmail - 使用图形验证码')
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'changeEmail',
            requestUrl: '/web/security/email/update',
            sceneType: 9, // 邮箱换绑场景
            host: set_host,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
        }
      }).catch(function(err) {
        // Promise 异常，降级到图形验证码
        console.error('阿里验证码初始化异常，降级使用图形验证码', err)
        captchaData = captchaData || {}
        _t.captchaSendFn(privateParams, {
          requestName: 'changeEmail',
          requestUrl: '/web/security/email/update',
          sceneType: 9, // 邮箱换绑场景
          host: set_host,
          checkToken: is_token,
          specialParams: setSpecialParams
        }, captchaData)
      })
    } else {
      // 没有初始化滑块，直接发送请求
      console.log('changeEmail 没有初始化滑块配置，直接发送请求')
      sendRequest()
    }
  },

  /*
  * @discribe 新绑邮箱（阿里验证码2.0风控）
  * @method setEmail
  * @param {params} 参数
  * @param {Object} captchaData 图形验证场景的数据传参
  * @return {Boolean} 返回一个Promise对象
  * */
  setEmail: function (params, captchaData) {
    console.log('setEmail 被调用, captchaData:', captchaData)

    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))

    var privateParams = getParams(params);
    // 验证邮箱为空
    if (!_util.validNotEmpty(privateParams.data.email)) {
      params.success(_util.getCode(1010017));
      return
    }
    // 验证验证码为空
    if (!_util.validNotEmpty(privateParams.data.vcode)) {
      params.success(_util.getCode(1010009));
      return
    }
    // 验证验证码合法性
    if (!_util.validVCode(privateParams.data.vcode)) {
      params.success(_util.getCode(1010013));
      return
    }

    var _t = this;
    var set_host = cg_host_v1;
    var is_token = true; // setEmail 需要登录态
    // 设置需要登录态的特殊参数
    var setSpecialParams = {
      isCheckLogin: true,
      name: 'setEmail'
    }

    var sendRequest = function (captchaVerifyParam) {
      console.log('setEmail sendRequest 被调用, captchaVerifyParam:', captchaVerifyParam)
      // 只有当 captchaVerifyParam 是字符串类型时，才认为是阿里无感验证码数据
      // 图形验证码数据是对象类型 {requestType: 1, captchaVal: '...'}
      if (captchaVerifyParam && typeof captchaVerifyParam === 'string') {
        try {
          let captchaVerifyParamObj = JSON.parse(captchaVerifyParam);
          // 确认包含 sceneId 字段，进一步确保是阿里验证码数据
          if (captchaVerifyParamObj && captchaVerifyParamObj.sceneId) {
            privateParams.data.invisible_sig = captchaVerifyParam;
            privateParams.data.invisible_sig_scene = captchaVerifyParamObj.sceneId;
            console.log('setEmail - 设置阿里无感验证码参数')
          }
        } catch (e) {
          console.warn('setEmail - 解析验证码参数失败:', e)
        }
      }
      console.log('setEmail 准备发送请求, 请求参数:', privateParams.data)

      _t.asyncCheckLogin().then(function (res) {
        _util.axiosPost(set_host + '/web/security/email/set', privateParams, setSpecialParams)
      }).catch(function (fail) {
        // 未登录，接口返回什么就是什么，原封不动返回给业务方
        if (fail.errcode) {
          params.success ? params.success(fail) : function (fail) { }
        } else {
          params.fail ? params.fail(fail) : function (fail) { }
        }
        params.complete ? params.complete(fail) : function (fail) { }
      })
    }

    // 如果是第二次校验（已经通过滑块验证），直接调用接口
    console.log('setEmail 判断是否已有验证数据: is_second_verify=', privateParams.data.is_second_verify, 'captchaData=', captchaData)
    if (captchaData) {
      console.log('setEmail - 已有验证数据，直接发送请求')
      sendRequest(captchaData)
      return
    }

    console.log('setEmail 未检测到验证数据，准备触发滑块')
    // 判断是否初始化滑块
    if (window.TAL_UC_PASSPORT_CONFIG_NVC_INIT) {
      console.log('setEmail - 开始等待阿里验证码初始化')
      window.TAL_UC_PASSPORT_CONFIG_NVC_INIT.then(function (res) {
        console.log('setEmail - 阿里验证码初始化完成', res)

        // 检查阿里验证码是否加载成功
        if (res && res.status === 'fail') {
          // 阿里验证码加载失败，降级到图形验证码
          console.log('阿里验证码加载失败，降级使用图形验证码', res.reason)
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'setEmail',
            requestUrl: '/web/security/email/set',
            sceneType: 9, // 邮箱设置场景
            host: set_host,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
          return;
        }

        // 阿里风控2.0能力调用
        if (window.initAliyunCaptcha) {
          console.log('setEmail - 触发阿里验证码')
          // 保存上下文，用于滑块成功后回调
          sdkCallbackContext = {
            method: 'setEmail',
            params: params,
            captchaData: null
          };
          // 触发阿里滑块按钮点击
          document.getElementById('tal-udc-captcha-button-for-aliyun').click()
          console.log('setEmail - 触发阿里验证码成功=====并点击了按钮')
        } else {
          // 没有 initAliyunCaptcha 方法，使用图形验证码
          console.log('setEmail - 使用图形验证码')
          captchaData = captchaData || {}
          _t.captchaSendFn(privateParams, {
            requestName: 'setEmail',
            requestUrl: '/web/security/email/set',
            sceneType: 9, // 邮箱设置场景
            host: set_host,
            checkToken: is_token,
            specialParams: setSpecialParams
          }, captchaData)
        }
      }).catch(function(err) {
        // Promise 异常，降级到图形验证码
        console.error('阿里验证码初始化异常，降级使用图形验证码', err)
        captchaData = captchaData || {}
        _t.captchaSendFn(privateParams, {
          requestName: 'setEmail',
          requestUrl: '/web/security/email/set',
          sceneType: 9, // 邮箱设置场景
          host: set_host,
          checkToken: is_token,
          specialParams: setSpecialParams
        }, captchaData)
      })
    } else {
      // 没有初始化滑块，直接发送请求
      console.log('setEmail 没有初始化滑块配置，直接发送请求')
      sendRequest()
    }
  },

  // ----------------- 风控2.0模块-------------------------------//
  /*
  * @discribe 登录验证码
  * @method loginSmsCodeSendCaptcha
  * @param {params} 登录参数
  * @return {Boolean}
  * */
  loginSmsCodeSendCaptcha: function (params) {
    const _this = this
    const { captcha_mode, container } = params.data;
    const containerElement = document.getElementById(container);

    if (captcha_mode === 'embed' && !containerElement) {
      return params.success(_util.getCode(1010019));
    }

    if (!document.getElementById('tal-loading')) {
      const loadingWrap = captcha_mode === 'embed' ? container : 'body';
      _util.talLoading(loadingWrap, ucresHost);
    }

    if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
    var privateParams = getParams(params)
    privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
    privateParams.data.captcha_type = privateParams.data.use || privateParams.data.captcha_type
    params.data.phone_code = params.data.phone_code ? params.data.phone_code : '86'
    params.data.captcha_type = params.data.use || params.data.captcha_type

    // 默认情况不走风控时，machine_check为空
    if (!privateParams.data.machine_check) {
      var machine_check = {
        type: 0
      }
      privateParams.data.machine_check = JSON.stringify(machine_check)
      params.data.machine_check = JSON.stringify(machine_check)
    }

    // 验证手机号为空
    if (!_util.validNotEmpty(privateParams.data.phone)) {
      params.success(_util.getCode(1010006));
      return
    }
    // 验证手机号合法性
    if (!_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
      params.success(_util.getCode(1010007));
      return
    }
    // 设置需要登录态的特殊参数
    const setSpecialParams = {
      isCheckLogin: true,
      name: 'loginSmsCodeSendCaptcha',
      isNewRisk: true
    }
    _util.axiosPost(
      `${passport_host_v2}/v2/web/captcha/send`,
      {
        data: privateParams.data || {},
        success: (res) => {
          if (res.errcode === 0) {
            handleCaptchaResponse(res, params);
          } else {
            _util.talCaptchaCallback('fail', params, res);
          }
        },
        fail: (err) => {
          // alert('err')
          // console.log(err,' err=========')
          err = err.errmsg ? err : { errcode: 1000000, errmsg: '网络错误' }
          _util.talCaptchaCallback('fail', params, err);
        },
      },
      setSpecialParams
    );

    function handleCaptchaResponse(res, params) {
      if (res.data.retry === 1) {
        const captchaEle = setupCaptchaElement(params);
        const options = createCaptchaOptions(params, captchaEle);
        console.log(options, 'options')
        options.env = params.data.env
        _TalCaptcha.Init(options).Check(res.data.retry_infos);
      } else {
        _util.talCaptchaCallback('send', params, res);
      }
    }

    function setupCaptchaElement(params) {
      let captchaEle;

      if (params.data.captcha_mode === 'embed') {
        captchaEle = document.getElementById(params.data.container);
        console.log(_TalCaptcha.config, ' _TalCaptcha.config')
        _TalCaptcha.config.close = false;
        console.log(_TalCaptcha.config, ' _TalCaptcha.config')
      } else {
        captchaEle = document.getElementById('tal-passport-captcha-recovery') || createRecoveryElement();
      }

      return captchaEle;
    }

    function createRecoveryElement() {
      const captchaEle = document.createElement('div');

      captchaEle.className = 'tal-passport-captcha-recovery';

      captchaEle.id = 'tal-passport-captcha-recovery';

      document.body.appendChild(captchaEle);

      return captchaEle;
    }

    function createCaptchaOptions(params, captchaEle) {
      return {
        div: captchaEle,
        onSuccess: (data, el) => handleCaptchaSuccess(data, el, params, captchaEle),
        onError: (e, el) => handleCaptchaError(e, el, params, captchaEle),
        onClose: (e, el) => handleCaptchaClose(e, el, params, captchaEle),
        onReady: (data, el) => handleCaptchaReady(data, el, params, captchaEle),
      };
    }

    function handleCaptchaSuccess(data, el, params, captchaEle) {
      _util.talCaptchaCallback('success', params, captchaEle, el, data);

      _this.loginSmsCodeSendCaptcha(params);
    }

    function handleCaptchaError(e, el, params, captchaEle) {
      _util.talCaptchaCallback('error', params, captchaEle, el, e);
    }

    function handleCaptchaClose(e, el, params, captchaEle) {
      _util.talCaptchaCallback('close', params, captchaEle, el);
    }

    function handleCaptchaReady(data, el, params, captchaEle) {
      _util.talCaptchaCallback('ready', params, captchaEle, el, data, ucresHost);
    }

  },
  /*
  * @discribe 海外google方式登录
  * @method overseasGoogleLogin
  * @param {params} 登录参数
  * @return {Boolean}
  * */
  overseasGoogleLogin: function (params) {
    let _this = this;
    //接收参数id、client_id、auto_select、ux_mode、button_type、button_theme、button_size、button_text、button_shape、button_logo_alignment、button_width、button_locale
    let containerId = params.data.containerId || '';
    let google_server_clientId = params.data.google_server_clientId;
    let auto_select = params.data.auto_select == 'true' ? true : false;
    let ux_mode = params.data.ux_mode || 'popup';
    let button_type = params.data.button_type || 'standard';
    let button_theme = params.data.button_theme || 'outline';
    let button_size = params.data.button_size || 'large';
    let button_text = params.data.button_text || 'signin_with';
    let button_shape = params.data.button_shape || 'rectangular';
    let button_logo_alignment = params.data.button_logo_alignment || 'left';
    let button_width = params.data.button_width || '400';
    let button_locale = params.data.button_locale || '';
    let click_listener = params.data.click_listener || function () { };
    let state = params.data.state || '';
    let nonce = _util.generateNonce();
    console.log(auto_select, 'auto_select================')
    _util.loadScriptUrl('https://accounts.google.com/gsi/client', () => {
      google.accounts.id.initialize({
        client_id: google_server_clientId,
        nonce: nonce,
        callback: (response) => {
          _this.handleCredentialResponse(response, params, nonce);
        },
        auto_select: auto_select // 启用自动选择
      });
      // Check if there is an existing session
      google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          // No existing session, display the sign-in button
          google.accounts.id.renderButton(
            document.getElementById(containerId),
            {
              ux_mode: ux_mode,
              type: button_type,
              theme: button_theme,
              size: button_size,
              text: button_text,
              shape: button_shape,
              logo_alignment: button_logo_alignment,
              width: button_width,
              locale: button_locale,
              click_listener: click_listener,
              state: state
            }
          );
        }
      });
    });
  },
  /*
  * @discribe google登录回调
  * @method handleCredentialResponse
  * @param {response} 登录参数
  * @return {Boolean}
  * */
  handleCredentialResponse(response, params, nonce) {
    console.log("Encoded JWT ID token: " + response.credential);
    console.log(params, 'params')
    // response.credential存在
    if (!response.credential) {
      params.fail ? params.fail({ errcode: 1010026, errmsg: 'Google登录失败' }) : function () { };
      return;
    }
    let googlLoginServerUrl = '';
    if (params.data.bindType == 1) {
      googlLoginServerUrl = passport_host_v1 + '/web/login/google/bind';
    } else {
      googlLoginServerUrl = passport_host_v1 + '/web/login/google';
    }
    // 重置请求参数
    var setParams = {
      data: {
        id_token: response.credential,
        nonce: nonce
      },
      success: function (res) {
        // 调取传递的回调方法
        params.success ? params.success(res) : function (res) { }
      },
      fail: function (fail) {
        params.fail ? params.fail(fail) : function (fail) { }
      },
      complete: function (res) {
        params.complete ? params.complete(res) : function (res) { }
      }
    }
    _util.axiosPost(googlLoginServerUrl, setParams)
  },
}
// Allow use of default import syntax in TypeScript
export default TAL_UC;



// WEBPACK FOOTER //
// ./src/index.js